import { s as Fo, i as Bn, u as Fe, j as qo, k as ko, l as Gn, m as Lo, p as $o, q as je, x as me, y as Vn, z as ct, A as Bo, B as Go, C as Un } from "./index-B7bwkLWz.mjs";
function jn(e) {
  var t = this.constructor;
  return this.then(
    function(r) {
      return t.resolve(e()).then(function() {
        return r;
      });
    },
    function(r) {
      return t.resolve(e()).then(function() {
        return t.reject(r);
      });
    }
  );
}
function Wn(e) {
  var t = this;
  return new t(function(r, n) {
    if (!(e && typeof e.length < "u"))
      return n(
        new TypeError(
          typeof e + " " + e + " is not iterable(cannot read property Symbol(Symbol.iterator))"
        )
      );
    var o = Array.prototype.slice.call(e);
    if (o.length === 0) return r([]);
    var c = o.length;
    function v(u, p) {
      if (p && (typeof p == "object" || typeof p == "function")) {
        var a = p.then;
        if (typeof a == "function") {
          a.call(
            p,
            function(i) {
              v(u, i);
            },
            function(i) {
              o[u] = { status: "rejected", reason: i }, --c === 0 && r(o);
            }
          );
          return;
        }
      }
      o[u] = { status: "fulfilled", value: p }, --c === 0 && r(o);
    }
    for (var d = 0; d < o.length; d++)
      v(d, o[d]);
  });
}
function Hn(e, t) {
  this.name = "AggregateError", this.errors = e, this.message = t || "";
}
Hn.prototype = Error.prototype;
function Kn(e) {
  var t = this;
  return new t(function(r, n) {
    if (!(e && typeof e.length < "u"))
      return n(new TypeError("Promise.any accepts an array"));
    var o = Array.prototype.slice.call(e);
    if (o.length === 0) return n();
    for (var c = [], v = 0; v < o.length; v++)
      try {
        t.resolve(o[v]).then(r).catch(function(d) {
          c.push(d), c.length === o.length && n(
            new Hn(
              c,
              "All promises were rejected"
            )
          );
        });
      } catch (d) {
        n(d);
      }
  });
}
var Vo = setTimeout;
function zn(e) {
  return !!(e && typeof e.length < "u");
}
function Uo() {
}
function jo(e, t) {
  return function() {
    e.apply(t, arguments);
  };
}
function oe(e) {
  if (!(this instanceof oe))
    throw new TypeError("Promises must be constructed via new");
  if (typeof e != "function") throw new TypeError("not a function");
  this._state = 0, this._handled = !1, this._value = void 0, this._deferreds = [], Jn(e, this);
}
function Qn(e, t) {
  for (; e._state === 3; )
    e = e._value;
  if (e._state === 0) {
    e._deferreds.push(t);
    return;
  }
  e._handled = !0, oe._immediateFn(function() {
    var r = e._state === 1 ? t.onFulfilled : t.onRejected;
    if (r === null) {
      (e._state === 1 ? ar : We)(t.promise, e._value);
      return;
    }
    var n;
    try {
      n = r(e._value);
    } catch (o) {
      We(t.promise, o);
      return;
    }
    ar(t.promise, n);
  });
}
function ar(e, t) {
  try {
    if (t === e)
      throw new TypeError("A promise cannot be resolved with itself.");
    if (t && (typeof t == "object" || typeof t == "function")) {
      var r = t.then;
      if (t instanceof oe) {
        e._state = 3, e._value = t, ir(e);
        return;
      } else if (typeof r == "function") {
        Jn(jo(r, t), e);
        return;
      }
    }
    e._state = 1, e._value = t, ir(e);
  } catch (n) {
    We(e, n);
  }
}
function We(e, t) {
  e._state = 2, e._value = t, ir(e);
}
function ir(e) {
  e._state === 2 && e._deferreds.length === 0 && oe._immediateFn(function() {
    e._handled || oe._unhandledRejectionFn(e._value);
  });
  for (var t = 0, r = e._deferreds.length; t < r; t++)
    Qn(e, e._deferreds[t]);
  e._deferreds = null;
}
function Wo(e, t, r) {
  this.onFulfilled = typeof e == "function" ? e : null, this.onRejected = typeof t == "function" ? t : null, this.promise = r;
}
function Jn(e, t) {
  var r = !1;
  try {
    e(
      function(n) {
        r || (r = !0, ar(t, n));
      },
      function(n) {
        r || (r = !0, We(t, n));
      }
    );
  } catch (n) {
    if (r) return;
    r = !0, We(t, n);
  }
}
oe.prototype.catch = function(e) {
  return this.then(null, e);
};
oe.prototype.then = function(e, t) {
  var r = new this.constructor(Uo);
  return Qn(this, new Wo(e, t, r)), r;
};
oe.prototype.finally = jn;
oe.all = function(e) {
  return new oe(function(t, r) {
    if (!zn(e))
      return r(new TypeError("Promise.all accepts an array"));
    var n = Array.prototype.slice.call(e);
    if (n.length === 0) return t([]);
    var o = n.length;
    function c(d, u) {
      try {
        if (u && (typeof u == "object" || typeof u == "function")) {
          var p = u.then;
          if (typeof p == "function") {
            p.call(
              u,
              function(a) {
                c(d, a);
              },
              r
            );
            return;
          }
        }
        n[d] = u, --o === 0 && t(n);
      } catch (a) {
        r(a);
      }
    }
    for (var v = 0; v < n.length; v++)
      c(v, n[v]);
  });
};
oe.any = Kn;
oe.allSettled = Wn;
oe.resolve = function(e) {
  return e && typeof e == "object" && e.constructor === oe ? e : new oe(function(t) {
    t(e);
  });
};
oe.reject = function(e) {
  return new oe(function(t, r) {
    r(e);
  });
};
oe.race = function(e) {
  return new oe(function(t, r) {
    if (!zn(e))
      return r(new TypeError("Promise.race accepts an array"));
    for (var n = 0, o = e.length; n < o; n++)
      oe.resolve(e[n]).then(t, r);
  });
};
oe._immediateFn = // @ts-ignore
typeof setImmediate == "function" && function(e) {
  setImmediate(e);
} || function(e) {
  Vo(e, 0);
};
oe._unhandledRejectionFn = function(t) {
  typeof console < "u" && console && console.warn("Possible Unhandled Promise Rejection:", t);
};
var Oe = (function() {
  if (typeof self < "u")
    return self;
  if (typeof window < "u")
    return window;
  if (typeof global < "u")
    return global;
  throw new Error("unable to locate global object");
})();
typeof Oe.Promise != "function" ? Oe.Promise = oe : (Oe.Promise.prototype.finally || (Oe.Promise.prototype.finally = jn), Oe.Promise.allSettled || (Oe.Promise.allSettled = Wn), Oe.Promise.any || (Oe.Promise.any = Kn));
Array.prototype.find || (Array.prototype.find = function(e) {
  if (this == null) throw new TypeError("Array.prototype.find called on null or undefined");
  if (typeof e != "function") throw new TypeError("predicate must be a function");
  for (var t = Object(this), r = t.length >>> 0, n = arguments[1], o = void 0, c = 0; c < r; c++) if (o = t[c], e.call(n, o, c, t)) return o;
});
Array.prototype.includes || (Array.prototype.includes = function(e) {
  if (this == null) throw new TypeError("Array.prototype.includes called on null or undefined");
  var t = Object(this), r = parseInt(t.length, 10) || 0;
  if (r === 0) return !1;
  var n, o, c = parseInt(arguments[1], 10) || 0;
  for (0 <= c ? n = c : (n = r + c) < 0 && (n = 0); n < r; ) {
    if (e === (o = t[n]) || e != e && o != o) return !0;
    n++;
  }
  return !1;
});
const Ir = {
  Vehicles: 3e3,
  Flowers: 2e3
};
function Ki(e) {
  var t = e.toLocaleString("en-GB"), r = t.indexOf(".") !== -1;
  return !r || r && e > 999 ? t : e.toFixed(2).toLocaleString("en-GB");
}
const zi = (e, t) => ((n) => n >= Ir.Flowers && n < Ir.Vehicles)(t) ? e.tags.includes("Letters") ? "Guide price per letter" : e.tags.includes("Garlands and single stem roses") ? "Guide price per stem" : "Guide price" : "from";
var Cr = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Ho(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function Ko(e) {
  if (Object.prototype.hasOwnProperty.call(e, "__esModule")) return e;
  var t = e.default;
  if (typeof t == "function") {
    var r = function n() {
      var o = !1;
      try {
        o = this instanceof n;
      } catch {
      }
      return o ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    r.prototype = t.prototype;
  } else r = {};
  return Object.defineProperty(r, "__esModule", { value: !0 }), Object.keys(e).forEach(function(n) {
    var o = Object.getOwnPropertyDescriptor(e, n);
    Object.defineProperty(r, n, o.get ? o : {
      enumerable: !0,
      get: function() {
        return e[n];
      }
    });
  }), r;
}
var st, xr;
function Le() {
  return xr || (xr = 1, st = TypeError), st;
}
const zo = {}, Qo = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: zo
}, Symbol.toStringTag, { value: "Module" })), Jo = /* @__PURE__ */ Ko(Qo);
var ft, Dr;
function Ye() {
  if (Dr) return ft;
  Dr = 1;
  var e = typeof Map == "function" && Map.prototype, t = Object.getOwnPropertyDescriptor && e ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null, r = e && t && typeof t.get == "function" ? t.get : null, n = e && Map.prototype.forEach, o = typeof Set == "function" && Set.prototype, c = Object.getOwnPropertyDescriptor && o ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null, v = o && c && typeof c.get == "function" ? c.get : null, d = o && Set.prototype.forEach, u = typeof WeakMap == "function" && WeakMap.prototype, p = u ? WeakMap.prototype.has : null, a = typeof WeakSet == "function" && WeakSet.prototype, i = a ? WeakSet.prototype.has : null, f = typeof WeakRef == "function" && WeakRef.prototype, y = f ? WeakRef.prototype.deref : null, l = Boolean.prototype.valueOf, E = Object.prototype.toString, s = Function.prototype.toString, S = String.prototype.match, b = String.prototype.slice, R = String.prototype.replace, G = String.prototype.toUpperCase, I = String.prototype.toLowerCase, B = RegExp.prototype.test, T = Array.prototype.concat, C = Array.prototype.join, w = Array.prototype.slice, O = Math.floor, A = typeof BigInt == "function" ? BigInt.prototype.valueOf : null, k = Object.getOwnPropertySymbols, W = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Symbol.prototype.toString : null, $ = typeof Symbol == "function" && typeof Symbol.iterator == "object", Y = typeof Symbol == "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === $ || !0) ? Symbol.toStringTag : null, z = Object.prototype.propertyIsEnumerable, H = (typeof Reflect == "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype ? function(h) {
    return h.__proto__;
  } : null);
  function X(h, m) {
    if (h === 1 / 0 || h === -1 / 0 || h !== h || h && h > -1e3 && h < 1e3 || B.call(/e/, m))
      return m;
    var J = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof h == "number") {
      var te = h < 0 ? -O(-h) : O(h);
      if (te !== h) {
        var re = String(te), U = b.call(m, re.length + 1);
        return R.call(re, J, "$&_") + "." + R.call(R.call(U, /([0-9]{3})/g, "$&_"), /_$/, "");
      }
    }
    return R.call(m, J, "$&_");
  }
  var Z = Jo, x = Z.custom, q = F(x) ? x : null, ne = {
    __proto__: null,
    double: '"',
    single: "'"
  }, ue = {
    __proto__: null,
    double: /(["\\])/g,
    single: /(['\\])/g
  };
  ft = function h(m, J, te, re) {
    var U = J || {};
    if (j(U, "quoteStyle") && !j(ne, U.quoteStyle))
      throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if (j(U, "maxStringLength") && (typeof U.maxStringLength == "number" ? U.maxStringLength < 0 && U.maxStringLength !== 1 / 0 : U.maxStringLength !== null))
      throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var be = j(U, "customInspect") ? U.customInspect : !0;
    if (typeof be != "boolean" && be !== "symbol")
      throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
    if (j(U, "indent") && U.indent !== null && U.indent !== "	" && !(parseInt(U.indent, 10) === U.indent && U.indent > 0))
      throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if (j(U, "numericSeparator") && typeof U.numericSeparator != "boolean")
      throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var Pe = U.numericSeparator;
    if (typeof m > "u")
      return "undefined";
    if (m === null)
      return "null";
    if (typeof m == "boolean")
      return m ? "true" : "false";
    if (typeof m == "string")
      return Er(m, U);
    if (typeof m == "number") {
      if (m === 0)
        return 1 / 0 / m > 0 ? "0" : "-0";
      var se = String(m);
      return Pe ? X(m, se) : se;
    }
    if (typeof m == "bigint") {
      var Ae = String(m) + "n";
      return Pe ? X(m, Ae) : Ae;
    }
    var rt = typeof U.depth > "u" ? 5 : U.depth;
    if (typeof te > "u" && (te = 0), te >= rt && rt > 0 && typeof m == "object")
      return g(m) ? "[Array]" : "[Object]";
    var Te = Do(U, te);
    if (typeof re > "u")
      re = [];
    else if (we(re, m) >= 0)
      return "[Circular]";
    function ve(Me, ze, Mo) {
      if (ze && (re = w.call(re), re.push(ze)), Mo) {
        var Nr = {
          depth: U.depth
        };
        return j(U, "quoteStyle") && (Nr.quoteStyle = U.quoteStyle), h(Me, Nr, te + 1, re);
      }
      return h(Me, U, te + 1, re);
    }
    if (typeof m == "function" && !_(m)) {
      var br = Ie(m), Ar = He(m, ve);
      return "[Function" + (br ? ": " + br : " (anonymous)") + "]" + (Ar.length > 0 ? " { " + C.call(Ar, ", ") + " }" : "");
    }
    if (F(m)) {
      var Or = $ ? R.call(String(m), /^(Symbol\(.*\))_[^)]*$/, "$1") : W.call(m);
      return typeof m == "object" && !$ ? $e(Or) : Or;
    }
    if (Io(m)) {
      for (var Be = "<" + I.call(String(m.nodeName)), nt = m.attributes || [], Ke = 0; Ke < nt.length; Ke++)
        Be += " " + nt[Ke].name + "=" + pe(de(nt[Ke].value), "double", U);
      return Be += ">", m.childNodes && m.childNodes.length && (Be += "..."), Be += "</" + I.call(String(m.nodeName)) + ">", Be;
    }
    if (g(m)) {
      if (m.length === 0)
        return "[]";
      var ot = He(m, ve);
      return Te && !xo(ot) ? "[" + tt(ot, Te) + "]" : "[ " + C.call(ot, ", ") + " ]";
    }
    if (P(m)) {
      var at = He(m, ve);
      return !("cause" in Error.prototype) && "cause" in m && !z.call(m, "cause") ? "{ [" + String(m) + "] " + C.call(T.call("[cause]: " + ve(m.cause), at), ", ") + " }" : at.length === 0 ? "[" + String(m) + "]" : "{ [" + String(m) + "] " + C.call(at, ", ") + " }";
    }
    if (typeof m == "object" && be) {
      if (q && typeof m[q] == "function" && Z)
        return Z(m, { depth: rt - te });
      if (be !== "symbol" && typeof m.inspect == "function")
        return m.inspect();
    }
    if (he(m)) {
      var Sr = [];
      return n && n.call(m, function(Me, ze) {
        Sr.push(ve(ze, m, !0) + " => " + ve(Me, m));
      }), wr("Map", r.call(m), Sr, Te);
    }
    if (De(m)) {
      var _r = [];
      return d && d.call(m, function(Me) {
        _r.push(ve(Me, m));
      }), wr("Set", v.call(m), _r, Te);
    }
    if (Ce(m))
      return et("WeakMap");
    if (No(m))
      return et("WeakSet");
    if (xe(m))
      return et("WeakRef");
    if (L(m))
      return $e(ve(Number(m)));
    if (K(m))
      return $e(ve(A.call(m)));
    if (M(m))
      return $e(l.call(m));
    if (D(m))
      return $e(ve(String(m)));
    if (typeof window < "u" && m === window)
      return "{ [object Window] }";
    if (typeof globalThis < "u" && m === globalThis || typeof Cr < "u" && m === Cr)
      return "{ [object globalThis] }";
    if (!N(m) && !_(m)) {
      var it = He(m, ve), Rr = H ? H(m) === Object.prototype : m instanceof Object || m.constructor === Object, lt = m instanceof Object ? "" : "null prototype", Pr = !Rr && Y && Object(m) === m && Y in m ? b.call(ye(m), 8, -1) : lt ? "Object" : "", To = Rr || typeof m.constructor != "function" ? "" : m.constructor.name ? m.constructor.name + " " : "", ut = To + (Pr || lt ? "[" + C.call(T.call([], Pr || [], lt || []), ": ") + "] " : "");
      return it.length === 0 ? ut + "{}" : Te ? ut + "{" + tt(it, Te) + "}" : ut + "{ " + C.call(it, ", ") + " }";
    }
    return String(m);
  };
  function pe(h, m, J) {
    var te = J.quoteStyle || m, re = ne[te];
    return re + h + re;
  }
  function de(h) {
    return R.call(String(h), /"/g, "&quot;");
  }
  function ie(h) {
    return !Y || !(typeof h == "object" && (Y in h || typeof h[Y] < "u"));
  }
  function g(h) {
    return ye(h) === "[object Array]" && ie(h);
  }
  function N(h) {
    return ye(h) === "[object Date]" && ie(h);
  }
  function _(h) {
    return ye(h) === "[object RegExp]" && ie(h);
  }
  function P(h) {
    return ye(h) === "[object Error]" && ie(h);
  }
  function D(h) {
    return ye(h) === "[object String]" && ie(h);
  }
  function L(h) {
    return ye(h) === "[object Number]" && ie(h);
  }
  function M(h) {
    return ye(h) === "[object Boolean]" && ie(h);
  }
  function F(h) {
    if ($)
      return h && typeof h == "object" && h instanceof Symbol;
    if (typeof h == "symbol")
      return !0;
    if (!h || typeof h != "object" || !W)
      return !1;
    try {
      return W.call(h), !0;
    } catch {
    }
    return !1;
  }
  function K(h) {
    if (!h || typeof h != "object" || !A)
      return !1;
    try {
      return A.call(h), !0;
    } catch {
    }
    return !1;
  }
  var ee = Object.prototype.hasOwnProperty || function(h) {
    return h in this;
  };
  function j(h, m) {
    return ee.call(h, m);
  }
  function ye(h) {
    return E.call(h);
  }
  function Ie(h) {
    if (h.name)
      return h.name;
    var m = S.call(s.call(h), /^function\s*([\w$]+)/);
    return m ? m[1] : null;
  }
  function we(h, m) {
    if (h.indexOf)
      return h.indexOf(m);
    for (var J = 0, te = h.length; J < te; J++)
      if (h[J] === m)
        return J;
    return -1;
  }
  function he(h) {
    if (!r || !h || typeof h != "object")
      return !1;
    try {
      r.call(h);
      try {
        v.call(h);
      } catch {
        return !0;
      }
      return h instanceof Map;
    } catch {
    }
    return !1;
  }
  function Ce(h) {
    if (!p || !h || typeof h != "object")
      return !1;
    try {
      p.call(h, p);
      try {
        i.call(h, i);
      } catch {
        return !0;
      }
      return h instanceof WeakMap;
    } catch {
    }
    return !1;
  }
  function xe(h) {
    if (!y || !h || typeof h != "object")
      return !1;
    try {
      return y.call(h), !0;
    } catch {
    }
    return !1;
  }
  function De(h) {
    if (!v || !h || typeof h != "object")
      return !1;
    try {
      v.call(h);
      try {
        r.call(h);
      } catch {
        return !0;
      }
      return h instanceof Set;
    } catch {
    }
    return !1;
  }
  function No(h) {
    if (!i || !h || typeof h != "object")
      return !1;
    try {
      i.call(h, i);
      try {
        p.call(h, p);
      } catch {
        return !0;
      }
      return h instanceof WeakSet;
    } catch {
    }
    return !1;
  }
  function Io(h) {
    return !h || typeof h != "object" ? !1 : typeof HTMLElement < "u" && h instanceof HTMLElement ? !0 : typeof h.nodeName == "string" && typeof h.getAttribute == "function";
  }
  function Er(h, m) {
    if (h.length > m.maxStringLength) {
      var J = h.length - m.maxStringLength, te = "... " + J + " more character" + (J > 1 ? "s" : "");
      return Er(b.call(h, 0, m.maxStringLength), m) + te;
    }
    var re = ue[m.quoteStyle || "single"];
    re.lastIndex = 0;
    var U = R.call(R.call(h, re, "\\$1"), /[\x00-\x1f]/g, Co);
    return pe(U, "single", m);
  }
  function Co(h) {
    var m = h.charCodeAt(0), J = {
      8: "b",
      9: "t",
      10: "n",
      12: "f",
      13: "r"
    }[m];
    return J ? "\\" + J : "\\x" + (m < 16 ? "0" : "") + G.call(m.toString(16));
  }
  function $e(h) {
    return "Object(" + h + ")";
  }
  function et(h) {
    return h + " { ? }";
  }
  function wr(h, m, J, te) {
    var re = te ? tt(J, te) : C.call(J, ", ");
    return h + " (" + m + ") {" + re + "}";
  }
  function xo(h) {
    for (var m = 0; m < h.length; m++)
      if (we(h[m], `
`) >= 0)
        return !1;
    return !0;
  }
  function Do(h, m) {
    var J;
    if (h.indent === "	")
      J = "	";
    else if (typeof h.indent == "number" && h.indent > 0)
      J = C.call(Array(h.indent + 1), " ");
    else
      return null;
    return {
      base: J,
      prev: C.call(Array(m + 1), J)
    };
  }
  function tt(h, m) {
    if (h.length === 0)
      return "";
    var J = `
` + m.prev + m.base;
    return J + C.call(h, "," + J) + `
` + m.prev;
  }
  function He(h, m) {
    var J = g(h), te = [];
    if (J) {
      te.length = h.length;
      for (var re = 0; re < h.length; re++)
        te[re] = j(h, re) ? m(h[re], h) : "";
    }
    var U = typeof k == "function" ? k(h) : [], be;
    if ($) {
      be = {};
      for (var Pe = 0; Pe < U.length; Pe++)
        be["$" + U[Pe]] = U[Pe];
    }
    for (var se in h)
      j(h, se) && (J && String(Number(se)) === se && se < h.length || $ && be["$" + se] instanceof Symbol || (B.call(/[^\w$]/, se) ? te.push(m(se, h) + ": " + m(h[se], h)) : te.push(se + ": " + m(h[se], h))));
    if (typeof k == "function")
      for (var Ae = 0; Ae < U.length; Ae++)
        z.call(h, U[Ae]) && te.push("[" + m(U[Ae]) + "]: " + m(h[U[Ae]], h));
    return te;
  }
  return ft;
}
var pt, Tr;
function Yo() {
  if (Tr) return pt;
  Tr = 1;
  var e = /* @__PURE__ */ Ye(), t = /* @__PURE__ */ Le(), r = function(d, u, p) {
    for (var a = d, i; (i = a.next) != null; a = i)
      if (i.key === u)
        return a.next = i.next, p || (i.next = /** @type {NonNullable<typeof list.next>} */
        d.next, d.next = i), i;
  }, n = function(d, u) {
    if (d) {
      var p = r(d, u);
      return p && p.value;
    }
  }, o = function(d, u, p) {
    var a = r(d, u);
    a ? a.value = p : d.next = /** @type {import('./list.d.ts').ListNode<typeof value, typeof key>} */
    {
      // eslint-disable-line no-param-reassign, no-extra-parens
      key: u,
      next: d.next,
      value: p
    };
  }, c = function(d, u) {
    return d ? !!r(d, u) : !1;
  }, v = function(d, u) {
    if (d)
      return r(d, u, !0);
  };
  return pt = function() {
    var u, p = {
      assert: function(a) {
        if (!p.has(a))
          throw new t("Side channel does not contain " + e(a));
      },
      delete: function(a) {
        var i = v(u, a);
        return i && u && !u.next && (u = void 0), !!i;
      },
      get: function(a) {
        return n(u, a);
      },
      has: function(a) {
        return c(u, a);
      },
      set: function(a, i) {
        u || (u = {
          next: void 0
        }), o(
          /** @type {NonNullable<typeof $o>} */
          u,
          a,
          i
        );
      }
    };
    return p;
  }, pt;
}
var dt, Mr;
function Yn() {
  return Mr || (Mr = 1, dt = Object), dt;
}
var yt, Fr;
function Xo() {
  return Fr || (Fr = 1, yt = Error), yt;
}
var ht, qr;
function Zo() {
  return qr || (qr = 1, ht = EvalError), ht;
}
var vt, kr;
function ea() {
  return kr || (kr = 1, vt = RangeError), vt;
}
var mt, Lr;
function ta() {
  return Lr || (Lr = 1, mt = ReferenceError), mt;
}
var gt, $r;
function ra() {
  return $r || ($r = 1, gt = SyntaxError), gt;
}
var Et, Br;
function na() {
  return Br || (Br = 1, Et = URIError), Et;
}
var wt, Gr;
function oa() {
  return Gr || (Gr = 1, wt = Math.abs), wt;
}
var bt, Vr;
function aa() {
  return Vr || (Vr = 1, bt = Math.floor), bt;
}
var At, Ur;
function ia() {
  return Ur || (Ur = 1, At = Math.max), At;
}
var Ot, jr;
function la() {
  return jr || (jr = 1, Ot = Math.min), Ot;
}
var St, Wr;
function ua() {
  return Wr || (Wr = 1, St = Math.pow), St;
}
var _t, Hr;
function ca() {
  return Hr || (Hr = 1, _t = Math.round), _t;
}
var Rt, Kr;
function sa() {
  return Kr || (Kr = 1, Rt = Number.isNaN || function(t) {
    return t !== t;
  }), Rt;
}
var Pt, zr;
function fa() {
  if (zr) return Pt;
  zr = 1;
  var e = /* @__PURE__ */ sa();
  return Pt = function(r) {
    return e(r) || r === 0 ? r : r < 0 ? -1 : 1;
  }, Pt;
}
var Nt, Qr;
function pa() {
  return Qr || (Qr = 1, Nt = Object.getOwnPropertyDescriptor), Nt;
}
var It, Jr;
function Xn() {
  if (Jr) return It;
  Jr = 1;
  var e = /* @__PURE__ */ pa();
  if (e)
    try {
      e([], "length");
    } catch {
      e = null;
    }
  return It = e, It;
}
var Ct, Yr;
function Zn() {
  if (Yr) return Ct;
  Yr = 1;
  var e = Object.defineProperty || !1;
  if (e)
    try {
      e({}, "a", { value: 1 });
    } catch {
      e = !1;
    }
  return Ct = e, Ct;
}
var xt, Xr;
function da() {
  return Xr || (Xr = 1, xt = function() {
    if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function")
      return !1;
    if (typeof Symbol.iterator == "symbol")
      return !0;
    var t = {}, r = /* @__PURE__ */ Symbol("test"), n = Object(r);
    if (typeof r == "string" || Object.prototype.toString.call(r) !== "[object Symbol]" || Object.prototype.toString.call(n) !== "[object Symbol]")
      return !1;
    var o = 42;
    t[r] = o;
    for (var c in t)
      return !1;
    if (typeof Object.keys == "function" && Object.keys(t).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(t).length !== 0)
      return !1;
    var v = Object.getOwnPropertySymbols(t);
    if (v.length !== 1 || v[0] !== r || !Object.prototype.propertyIsEnumerable.call(t, r))
      return !1;
    if (typeof Object.getOwnPropertyDescriptor == "function") {
      var d = (
        /** @type {PropertyDescriptor} */
        Object.getOwnPropertyDescriptor(t, r)
      );
      if (d.value !== o || d.enumerable !== !0)
        return !1;
    }
    return !0;
  }), xt;
}
var Dt, Zr;
function ya() {
  if (Zr) return Dt;
  Zr = 1;
  var e = typeof Symbol < "u" && Symbol, t = da();
  return Dt = function() {
    return typeof e != "function" || typeof Symbol != "function" || typeof e("foo") != "symbol" || typeof /* @__PURE__ */ Symbol("bar") != "symbol" ? !1 : t();
  }, Dt;
}
var Tt, en;
function eo() {
  return en || (en = 1, Tt = typeof Reflect < "u" && Reflect.getPrototypeOf || null), Tt;
}
var Mt, tn;
function to() {
  if (tn) return Mt;
  tn = 1;
  var e = /* @__PURE__ */ Yn();
  return Mt = e.getPrototypeOf || null, Mt;
}
var Ft, rn;
function ha() {
  if (rn) return Ft;
  rn = 1;
  var e = "Function.prototype.bind called on incompatible ", t = Object.prototype.toString, r = Math.max, n = "[object Function]", o = function(u, p) {
    for (var a = [], i = 0; i < u.length; i += 1)
      a[i] = u[i];
    for (var f = 0; f < p.length; f += 1)
      a[f + u.length] = p[f];
    return a;
  }, c = function(u, p) {
    for (var a = [], i = p, f = 0; i < u.length; i += 1, f += 1)
      a[f] = u[i];
    return a;
  }, v = function(d, u) {
    for (var p = "", a = 0; a < d.length; a += 1)
      p += d[a], a + 1 < d.length && (p += u);
    return p;
  };
  return Ft = function(u) {
    var p = this;
    if (typeof p != "function" || t.apply(p) !== n)
      throw new TypeError(e + p);
    for (var a = c(arguments, 1), i, f = function() {
      if (this instanceof i) {
        var S = p.apply(
          this,
          o(a, arguments)
        );
        return Object(S) === S ? S : this;
      }
      return p.apply(
        u,
        o(a, arguments)
      );
    }, y = r(0, p.length - a.length), l = [], E = 0; E < y; E++)
      l[E] = "$" + E;
    if (i = Function("binder", "return function (" + v(l, ",") + "){ return binder.apply(this,arguments); }")(f), p.prototype) {
      var s = function() {
      };
      s.prototype = p.prototype, i.prototype = new s(), s.prototype = null;
    }
    return i;
  }, Ft;
}
var qt, nn;
function Xe() {
  if (nn) return qt;
  nn = 1;
  var e = ha();
  return qt = Function.prototype.bind || e, qt;
}
var kt, on;
function yr() {
  return on || (on = 1, kt = Function.prototype.call), kt;
}
var Lt, an;
function ro() {
  return an || (an = 1, Lt = Function.prototype.apply), Lt;
}
var $t, ln;
function va() {
  return ln || (ln = 1, $t = typeof Reflect < "u" && Reflect && Reflect.apply), $t;
}
var Bt, un;
function ma() {
  if (un) return Bt;
  un = 1;
  var e = Xe(), t = ro(), r = yr(), n = va();
  return Bt = n || e.call(r, t), Bt;
}
var Gt, cn;
function no() {
  if (cn) return Gt;
  cn = 1;
  var e = Xe(), t = /* @__PURE__ */ Le(), r = yr(), n = ma();
  return Gt = function(c) {
    if (c.length < 1 || typeof c[0] != "function")
      throw new t("a function is required");
    return n(e, r, c);
  }, Gt;
}
var Vt, sn;
function ga() {
  if (sn) return Vt;
  sn = 1;
  var e = no(), t = /* @__PURE__ */ Xn(), r;
  try {
    r = /** @type {{ __proto__?: typeof Array.prototype }} */
    [].__proto__ === Array.prototype;
  } catch (v) {
    if (!v || typeof v != "object" || !("code" in v) || v.code !== "ERR_PROTO_ACCESS")
      throw v;
  }
  var n = !!r && t && t(
    Object.prototype,
    /** @type {keyof typeof Object.prototype} */
    "__proto__"
  ), o = Object, c = o.getPrototypeOf;
  return Vt = n && typeof n.get == "function" ? e([n.get]) : typeof c == "function" ? (
    /** @type {import('./get')} */
    function(d) {
      return c(d == null ? d : o(d));
    }
  ) : !1, Vt;
}
var Ut, fn;
function Ea() {
  if (fn) return Ut;
  fn = 1;
  var e = eo(), t = to(), r = /* @__PURE__ */ ga();
  return Ut = e ? function(o) {
    return e(o);
  } : t ? function(o) {
    if (!o || typeof o != "object" && typeof o != "function")
      throw new TypeError("getProto: not an object");
    return t(o);
  } : r ? function(o) {
    return r(o);
  } : null, Ut;
}
var jt, pn;
function wa() {
  if (pn) return jt;
  pn = 1;
  var e = Function.prototype.call, t = Object.prototype.hasOwnProperty, r = Xe();
  return jt = r.call(e, t), jt;
}
var Wt, dn;
function hr() {
  if (dn) return Wt;
  dn = 1;
  var e, t = /* @__PURE__ */ Yn(), r = /* @__PURE__ */ Xo(), n = /* @__PURE__ */ Zo(), o = /* @__PURE__ */ ea(), c = /* @__PURE__ */ ta(), v = /* @__PURE__ */ ra(), d = /* @__PURE__ */ Le(), u = /* @__PURE__ */ na(), p = /* @__PURE__ */ oa(), a = /* @__PURE__ */ aa(), i = /* @__PURE__ */ ia(), f = /* @__PURE__ */ la(), y = /* @__PURE__ */ ua(), l = /* @__PURE__ */ ca(), E = /* @__PURE__ */ fa(), s = Function, S = function(_) {
    try {
      return s('"use strict"; return (' + _ + ").constructor;")();
    } catch {
    }
  }, b = /* @__PURE__ */ Xn(), R = /* @__PURE__ */ Zn(), G = function() {
    throw new d();
  }, I = b ? (function() {
    try {
      return arguments.callee, G;
    } catch {
      try {
        return b(arguments, "callee").get;
      } catch {
        return G;
      }
    }
  })() : G, B = ya()(), T = Ea(), C = to(), w = eo(), O = ro(), A = yr(), k = {}, W = typeof Uint8Array > "u" || !T ? e : T(Uint8Array), $ = {
    __proto__: null,
    "%AggregateError%": typeof AggregateError > "u" ? e : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer > "u" ? e : ArrayBuffer,
    "%ArrayIteratorPrototype%": B && T ? T([][Symbol.iterator]()) : e,
    "%AsyncFromSyncIteratorPrototype%": e,
    "%AsyncFunction%": k,
    "%AsyncGenerator%": k,
    "%AsyncGeneratorFunction%": k,
    "%AsyncIteratorPrototype%": k,
    "%Atomics%": typeof Atomics > "u" ? e : Atomics,
    "%BigInt%": typeof BigInt > "u" ? e : BigInt,
    "%BigInt64Array%": typeof BigInt64Array > "u" ? e : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array > "u" ? e : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView > "u" ? e : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": r,
    "%eval%": eval,
    // eslint-disable-line no-eval
    "%EvalError%": n,
    "%Float16Array%": typeof Float16Array > "u" ? e : Float16Array,
    "%Float32Array%": typeof Float32Array > "u" ? e : Float32Array,
    "%Float64Array%": typeof Float64Array > "u" ? e : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? e : FinalizationRegistry,
    "%Function%": s,
    "%GeneratorFunction%": k,
    "%Int8Array%": typeof Int8Array > "u" ? e : Int8Array,
    "%Int16Array%": typeof Int16Array > "u" ? e : Int16Array,
    "%Int32Array%": typeof Int32Array > "u" ? e : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": B && T ? T(T([][Symbol.iterator]())) : e,
    "%JSON%": typeof JSON == "object" ? JSON : e,
    "%Map%": typeof Map > "u" ? e : Map,
    "%MapIteratorPrototype%": typeof Map > "u" || !B || !T ? e : T((/* @__PURE__ */ new Map())[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": t,
    "%Object.getOwnPropertyDescriptor%": b,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise > "u" ? e : Promise,
    "%Proxy%": typeof Proxy > "u" ? e : Proxy,
    "%RangeError%": o,
    "%ReferenceError%": c,
    "%Reflect%": typeof Reflect > "u" ? e : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set > "u" ? e : Set,
    "%SetIteratorPrototype%": typeof Set > "u" || !B || !T ? e : T((/* @__PURE__ */ new Set())[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? e : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": B && T ? T(""[Symbol.iterator]()) : e,
    "%Symbol%": B ? Symbol : e,
    "%SyntaxError%": v,
    "%ThrowTypeError%": I,
    "%TypedArray%": W,
    "%TypeError%": d,
    "%Uint8Array%": typeof Uint8Array > "u" ? e : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? e : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array > "u" ? e : Uint16Array,
    "%Uint32Array%": typeof Uint32Array > "u" ? e : Uint32Array,
    "%URIError%": u,
    "%WeakMap%": typeof WeakMap > "u" ? e : WeakMap,
    "%WeakRef%": typeof WeakRef > "u" ? e : WeakRef,
    "%WeakSet%": typeof WeakSet > "u" ? e : WeakSet,
    "%Function.prototype.call%": A,
    "%Function.prototype.apply%": O,
    "%Object.defineProperty%": R,
    "%Object.getPrototypeOf%": C,
    "%Math.abs%": p,
    "%Math.floor%": a,
    "%Math.max%": i,
    "%Math.min%": f,
    "%Math.pow%": y,
    "%Math.round%": l,
    "%Math.sign%": E,
    "%Reflect.getPrototypeOf%": w
  };
  if (T)
    try {
      null.error;
    } catch (_) {
      var Y = T(T(_));
      $["%Error.prototype%"] = Y;
    }
  var z = function _(P) {
    var D;
    if (P === "%AsyncFunction%")
      D = S("async function () {}");
    else if (P === "%GeneratorFunction%")
      D = S("function* () {}");
    else if (P === "%AsyncGeneratorFunction%")
      D = S("async function* () {}");
    else if (P === "%AsyncGenerator%") {
      var L = _("%AsyncGeneratorFunction%");
      L && (D = L.prototype);
    } else if (P === "%AsyncIteratorPrototype%") {
      var M = _("%AsyncGenerator%");
      M && T && (D = T(M.prototype));
    }
    return $[P] = D, D;
  }, H = {
    __proto__: null,
    "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
    "%ArrayPrototype%": ["Array", "prototype"],
    "%ArrayProto_entries%": ["Array", "prototype", "entries"],
    "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
    "%ArrayProto_keys%": ["Array", "prototype", "keys"],
    "%ArrayProto_values%": ["Array", "prototype", "values"],
    "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
    "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
    "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
    "%BooleanPrototype%": ["Boolean", "prototype"],
    "%DataViewPrototype%": ["DataView", "prototype"],
    "%DatePrototype%": ["Date", "prototype"],
    "%ErrorPrototype%": ["Error", "prototype"],
    "%EvalErrorPrototype%": ["EvalError", "prototype"],
    "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
    "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
    "%FunctionPrototype%": ["Function", "prototype"],
    "%Generator%": ["GeneratorFunction", "prototype"],
    "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
    "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
    "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
    "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
    "%JSONParse%": ["JSON", "parse"],
    "%JSONStringify%": ["JSON", "stringify"],
    "%MapPrototype%": ["Map", "prototype"],
    "%NumberPrototype%": ["Number", "prototype"],
    "%ObjectPrototype%": ["Object", "prototype"],
    "%ObjProto_toString%": ["Object", "prototype", "toString"],
    "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
    "%PromisePrototype%": ["Promise", "prototype"],
    "%PromiseProto_then%": ["Promise", "prototype", "then"],
    "%Promise_all%": ["Promise", "all"],
    "%Promise_reject%": ["Promise", "reject"],
    "%Promise_resolve%": ["Promise", "resolve"],
    "%RangeErrorPrototype%": ["RangeError", "prototype"],
    "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
    "%RegExpPrototype%": ["RegExp", "prototype"],
    "%SetPrototype%": ["Set", "prototype"],
    "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
    "%StringPrototype%": ["String", "prototype"],
    "%SymbolPrototype%": ["Symbol", "prototype"],
    "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
    "%TypedArrayPrototype%": ["TypedArray", "prototype"],
    "%TypeErrorPrototype%": ["TypeError", "prototype"],
    "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
    "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
    "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
    "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
    "%URIErrorPrototype%": ["URIError", "prototype"],
    "%WeakMapPrototype%": ["WeakMap", "prototype"],
    "%WeakSetPrototype%": ["WeakSet", "prototype"]
  }, X = Xe(), Z = /* @__PURE__ */ wa(), x = X.call(A, Array.prototype.concat), q = X.call(O, Array.prototype.splice), ne = X.call(A, String.prototype.replace), ue = X.call(A, String.prototype.slice), pe = X.call(A, RegExp.prototype.exec), de = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, ie = /\\(\\)?/g, g = function(P) {
    var D = ue(P, 0, 1), L = ue(P, -1);
    if (D === "%" && L !== "%")
      throw new v("invalid intrinsic syntax, expected closing `%`");
    if (L === "%" && D !== "%")
      throw new v("invalid intrinsic syntax, expected opening `%`");
    var M = [];
    return ne(P, de, function(F, K, ee, j) {
      M[M.length] = ee ? ne(j, ie, "$1") : K || F;
    }), M;
  }, N = function(P, D) {
    var L = P, M;
    if (Z(H, L) && (M = H[L], L = "%" + M[0] + "%"), Z($, L)) {
      var F = $[L];
      if (F === k && (F = z(L)), typeof F > "u" && !D)
        throw new d("intrinsic " + P + " exists, but is not available. Please file an issue!");
      return {
        alias: M,
        name: L,
        value: F
      };
    }
    throw new v("intrinsic " + P + " does not exist!");
  };
  return Wt = function(P, D) {
    if (typeof P != "string" || P.length === 0)
      throw new d("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof D != "boolean")
      throw new d('"allowMissing" argument must be a boolean');
    if (pe(/^%?[^%]*%?$/, P) === null)
      throw new v("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var L = g(P), M = L.length > 0 ? L[0] : "", F = N("%" + M + "%", D), K = F.name, ee = F.value, j = !1, ye = F.alias;
    ye && (M = ye[0], q(L, x([0, 1], ye)));
    for (var Ie = 1, we = !0; Ie < L.length; Ie += 1) {
      var he = L[Ie], Ce = ue(he, 0, 1), xe = ue(he, -1);
      if ((Ce === '"' || Ce === "'" || Ce === "`" || xe === '"' || xe === "'" || xe === "`") && Ce !== xe)
        throw new v("property names with quotes must have matching quotes");
      if ((he === "constructor" || !we) && (j = !0), M += "." + he, K = "%" + M + "%", Z($, K))
        ee = $[K];
      else if (ee != null) {
        if (!(he in ee)) {
          if (!D)
            throw new d("base intrinsic for " + P + " exists, but the property is not available.");
          return;
        }
        if (b && Ie + 1 >= L.length) {
          var De = b(ee, he);
          we = !!De, we && "get" in De && !("originalValue" in De.get) ? ee = De.get : ee = ee[he];
        } else
          we = Z(ee, he), ee = ee[he];
        we && !j && ($[K] = ee);
      }
    }
    return ee;
  }, Wt;
}
var Ht, yn;
function oo() {
  if (yn) return Ht;
  yn = 1;
  var e = /* @__PURE__ */ hr(), t = no(), r = t([e("%String.prototype.indexOf%")]);
  return Ht = function(o, c) {
    var v = (
      /** @type {(this: unknown, ...args: unknown[]) => unknown} */
      e(o, !!c)
    );
    return typeof v == "function" && r(o, ".prototype.") > -1 ? t(
      /** @type {const} */
      [v]
    ) : v;
  }, Ht;
}
var Kt, hn;
function ao() {
  if (hn) return Kt;
  hn = 1;
  var e = /* @__PURE__ */ hr(), t = /* @__PURE__ */ oo(), r = /* @__PURE__ */ Ye(), n = /* @__PURE__ */ Le(), o = e("%Map%", !0), c = t("Map.prototype.get", !0), v = t("Map.prototype.set", !0), d = t("Map.prototype.has", !0), u = t("Map.prototype.delete", !0), p = t("Map.prototype.size", !0);
  return Kt = !!o && /** @type {Exclude<import('.'), false>} */
  function() {
    var i, f = {
      assert: function(y) {
        if (!f.has(y))
          throw new n("Side channel does not contain " + r(y));
      },
      delete: function(y) {
        if (i) {
          var l = u(i, y);
          return p(i) === 0 && (i = void 0), l;
        }
        return !1;
      },
      get: function(y) {
        if (i)
          return c(i, y);
      },
      has: function(y) {
        return i ? d(i, y) : !1;
      },
      set: function(y, l) {
        i || (i = new o()), v(i, y, l);
      }
    };
    return f;
  }, Kt;
}
var zt, vn;
function ba() {
  if (vn) return zt;
  vn = 1;
  var e = /* @__PURE__ */ hr(), t = /* @__PURE__ */ oo(), r = /* @__PURE__ */ Ye(), n = ao(), o = /* @__PURE__ */ Le(), c = e("%WeakMap%", !0), v = t("WeakMap.prototype.get", !0), d = t("WeakMap.prototype.set", !0), u = t("WeakMap.prototype.has", !0), p = t("WeakMap.prototype.delete", !0);
  return zt = c ? (
    /** @type {Exclude<import('.'), false>} */
    function() {
      var i, f, y = {
        assert: function(l) {
          if (!y.has(l))
            throw new o("Side channel does not contain " + r(l));
        },
        delete: function(l) {
          if (c && l && (typeof l == "object" || typeof l == "function")) {
            if (i)
              return p(i, l);
          } else if (n && f)
            return f.delete(l);
          return !1;
        },
        get: function(l) {
          return c && l && (typeof l == "object" || typeof l == "function") && i ? v(i, l) : f && f.get(l);
        },
        has: function(l) {
          return c && l && (typeof l == "object" || typeof l == "function") && i ? u(i, l) : !!f && f.has(l);
        },
        set: function(l, E) {
          c && l && (typeof l == "object" || typeof l == "function") ? (i || (i = new c()), d(i, l, E)) : n && (f || (f = n()), f.set(l, E));
        }
      };
      return y;
    }
  ) : n, zt;
}
var Qt, mn;
function io() {
  if (mn) return Qt;
  mn = 1;
  var e = /* @__PURE__ */ Le(), t = /* @__PURE__ */ Ye(), r = Yo(), n = ao(), o = ba(), c = o || n || r;
  return Qt = function() {
    var d, u = {
      assert: function(p) {
        if (!u.has(p)) {
          var a = p && Object(p) === p ? "the given object key" : t(p);
          throw new e("Side channel does not contain " + a);
        }
      },
      delete: function(p) {
        return !!d && d.delete(p);
      },
      get: function(p) {
        return d && d.get(p);
      },
      has: function(p) {
        return !!d && d.has(p);
      },
      set: function(p, a) {
        d || (d = c()), d.set(p, a);
      }
    };
    return u;
  }, Qt;
}
var Jt, gn;
function vr() {
  if (gn) return Jt;
  gn = 1;
  var e = String.prototype.replace, t = /%20/g, r = {
    RFC1738: "RFC1738",
    RFC3986: "RFC3986"
  };
  return Jt = {
    default: r.RFC3986,
    formatters: {
      RFC1738: function(n) {
        return e.call(n, t, "+");
      },
      RFC3986: function(n) {
        return String(n);
      }
    },
    RFC1738: r.RFC1738,
    RFC3986: r.RFC3986
  }, Jt;
}
var Yt, En;
function lo() {
  if (En) return Yt;
  En = 1;
  var e = /* @__PURE__ */ vr(), t = io(), r = /* @__PURE__ */ Zn(), n = Object.prototype.hasOwnProperty, o = Array.isArray, c = t(), v = function(w, O) {
    return c.set(w, O), w;
  }, d = function(w) {
    return c.has(w);
  }, u = function(w) {
    return c.get(w);
  }, p = function(w, O) {
    c.set(w, O);
  }, a = (function() {
    for (var C = [], w = 0; w < 256; ++w)
      C[C.length] = "%" + ((w < 16 ? "0" : "") + w.toString(16)).toUpperCase();
    return C;
  })(), i = function(w) {
    for (; w.length > 1; ) {
      var O = w.pop(), A = O.obj[O.prop];
      if (o(A)) {
        for (var k = [], W = 0; W < A.length; ++W)
          typeof A[W] < "u" && (k[k.length] = A[W]);
        O.obj[O.prop] = k;
      }
    }
  }, f = function(w, O) {
    for (var A = O && O.plainObjects ? { __proto__: null } : {}, k = 0; k < w.length; ++k)
      typeof w[k] < "u" && (A[k] = w[k]);
    return A;
  }, y = function(w, O, A) {
    O === "__proto__" && r ? r(w, O, {
      configurable: !0,
      enumerable: !0,
      value: A,
      writable: !0
    }) : w[O] = A;
  }, l = function C(w, O, A) {
    if (!O)
      return w;
    if (typeof O != "object" && typeof O != "function") {
      if (o(w)) {
        var k = w.length;
        if (A && typeof A.arrayLimit == "number" && k >= A.arrayLimit) {
          if (A.throwOnLimitExceeded)
            throw new RangeError("Array limit exceeded. Only " + A.arrayLimit + " element" + (A.arrayLimit === 1 ? "" : "s") + " allowed in an array.");
          return v(f(w.concat(O), A), k);
        }
        w[k] = O;
      } else if (w && typeof w == "object")
        if (d(w)) {
          var W = u(w) + 1;
          w[W] = O, p(w, W);
        } else {
          if (A && A.strictMerge)
            return [w, O];
          (A && (A.plainObjects || A.allowPrototypes) || !n.call(Object.prototype, O)) && (w[O] = !0);
        }
      else
        return [w, O];
      return w;
    }
    if (!w || typeof w != "object") {
      if (d(O)) {
        for (var $ = Object.keys(O), Y = A && A.plainObjects ? { __proto__: null, 0: w } : { 0: w }, z = 0; z < $.length; z++) {
          var H = parseInt($[z], 10);
          Y[H + 1] = O[$[z]];
        }
        return v(Y, u(O) + 1);
      }
      var X = [w].concat(O);
      if (A && typeof A.arrayLimit == "number" && X.length > A.arrayLimit) {
        if (A.throwOnLimitExceeded)
          throw new RangeError("Array limit exceeded. Only " + A.arrayLimit + " element" + (A.arrayLimit === 1 ? "" : "s") + " allowed in an array.");
        return v(f(X, A), X.length - 1);
      }
      return X;
    }
    var Z = w;
    if (o(w) && !o(O) && (Z = f(w, A)), o(w) && o(O)) {
      if (O.forEach(function(x, q) {
        if (n.call(w, q)) {
          var ne = w[q];
          ne && typeof ne == "object" && x && typeof x == "object" ? w[q] = C(ne, x, A) : w[w.length] = x;
        } else
          w[q] = x;
      }), A && typeof A.arrayLimit == "number" && w.length > A.arrayLimit) {
        if (A.throwOnLimitExceeded)
          throw new RangeError("Array limit exceeded. Only " + A.arrayLimit + " element" + (A.arrayLimit === 1 ? "" : "s") + " allowed in an array.");
        return v(f(w, A), w.length - 1);
      }
      return w;
    }
    return Object.keys(O).reduce(function(x, q) {
      var ne = O[q];
      if (n.call(x, q) ? y(x, q, C(x[q], ne, A)) : y(x, q, ne), d(O) && !d(x) && v(x, u(O)), d(x)) {
        var ue = parseInt(q, 10);
        String(ue) === q && ue >= 0 && ue > u(x) && p(x, ue);
      }
      return x;
    }, Z);
  }, E = function(w, O) {
    return Object.keys(O).reduce(function(A, k) {
      return y(A, k, O[k]), A;
    }, w);
  }, s = function(C, w, O) {
    var A = C.replace(/\+/g, " ");
    if (O === "iso-8859-1")
      return A.replace(/%[0-9a-f]{2}/gi, unescape);
    try {
      return decodeURIComponent(A);
    } catch {
      return A;
    }
  }, S = 1024, b = function(w, O, A, k, W) {
    if (w.length === 0)
      return w;
    var $ = w;
    if (typeof w == "symbol" ? $ = Symbol.prototype.toString.call(w) : typeof w != "string" && ($ = String(w)), A === "iso-8859-1")
      return escape($).replace(/%u[0-9a-f]{4}/gi, function(ne) {
        return "%26%23" + parseInt(ne.slice(2), 16) + "%3B";
      });
    for (var Y = "", z = 0; z < $.length; z += S) {
      var H = $.length >= S ? $.slice(z, z + S) : $;
      if (z + S < $.length) {
        var X = H.charCodeAt(H.length - 1);
        X >= 55296 && X <= 56319 && (H = H.slice(0, -1), z -= 1);
      }
      for (var Z = [], x = 0; x < H.length; ++x) {
        var q = H.charCodeAt(x);
        if (q === 45 || q === 46 || q === 95 || q === 126 || q >= 48 && q <= 57 || q >= 65 && q <= 90 || q >= 97 && q <= 122 || W === e.RFC1738 && (q === 40 || q === 41)) {
          Z[Z.length] = H.charAt(x);
          continue;
        }
        if (q < 128) {
          Z[Z.length] = a[q];
          continue;
        }
        if (q < 2048) {
          Z[Z.length] = a[192 | q >> 6] + a[128 | q & 63];
          continue;
        }
        if (q < 55296 || q >= 57344) {
          Z[Z.length] = a[224 | q >> 12] + a[128 | q >> 6 & 63] + a[128 | q & 63];
          continue;
        }
        x += 1, q = 65536 + ((q & 1023) << 10 | H.charCodeAt(x) & 1023), Z[Z.length] = a[240 | q >> 18] + a[128 | q >> 12 & 63] + a[128 | q >> 6 & 63] + a[128 | q & 63];
      }
      Y += Z.join("");
    }
    return Y;
  }, R = function(w) {
    for (var O = [{ obj: { o: w }, prop: "o" }], A = t(), k = 0; k < O.length; ++k)
      for (var W = O[k], $ = W.obj[W.prop], Y = Object.keys($), z = 0; z < Y.length; ++z) {
        var H = Y[z], X = $[H];
        typeof X == "object" && X !== null && !A.has(X) && (O[O.length] = { obj: $, prop: H }, A.set(X, !0));
      }
    return i(O), w;
  }, G = function(w) {
    return Object.prototype.toString.call(w) === "[object RegExp]";
  }, I = function(w) {
    return !w || typeof w != "object" ? !1 : !!(w.constructor && typeof w.constructor.isBuffer == "function" && w.constructor.isBuffer(w));
  }, B = function(w, O, A, k, W) {
    if (d(w)) {
      if (W)
        throw new RangeError("Array limit exceeded. Only " + A + " element" + (A === 1 ? "" : "s") + " allowed in an array.");
      for (var $ = o(O) ? O : [O], Y = u(w), z = 0; z < $.length; ++z)
        Y += 1, w[Y] = $[z];
      return p(w, Y), w;
    }
    var H = [].concat(w, O);
    if (H.length > A) {
      if (W)
        throw new RangeError("Array limit exceeded. Only " + A + " element" + (A === 1 ? "" : "s") + " allowed in an array.");
      return v(f(H, { plainObjects: k }), H.length - 1);
    }
    return H;
  }, T = function(w, O) {
    if (o(w)) {
      for (var A = [], k = 0; k < w.length; k += 1)
        A[A.length] = O(w[k]);
      return A;
    }
    return O(w);
  };
  return Yt = {
    arrayToObject: f,
    assign: E,
    combine: B,
    compact: R,
    decode: s,
    encode: b,
    isBuffer: I,
    isOverflow: d,
    isRegExp: G,
    markOverflow: v,
    maybeMap: T,
    merge: l
  }, Yt;
}
var Xt, wn;
function Aa() {
  if (wn) return Xt;
  wn = 1;
  var e = io(), t = /* @__PURE__ */ lo(), r = /* @__PURE__ */ vr(), n = Object.prototype.hasOwnProperty, o = {
    brackets: function(s) {
      return s + "[]";
    },
    comma: "comma",
    indices: function(s, S) {
      return s + "[" + S + "]";
    },
    repeat: function(s) {
      return s;
    }
  }, c = Array.isArray, v = Array.prototype.push, d = function(E, s) {
    v.apply(E, c(s) ? s : [s]);
  }, u = Date.prototype.toISOString, p = r.default, a = {
    addQueryPrefix: !1,
    allowDots: !1,
    allowEmptyArrays: !1,
    arrayFormat: "indices",
    charset: "utf-8",
    charsetSentinel: !1,
    commaRoundTrip: !1,
    delimiter: "&",
    depth: 1 / 0,
    encode: !0,
    encodeDotInKeys: !1,
    encoder: t.encode,
    encodeValuesOnly: !1,
    filter: void 0,
    format: p,
    formatter: r.formatters[p],
    // deprecated
    indices: !1,
    serializeDate: function(s) {
      return u.call(s);
    },
    skipNulls: !1,
    strictNullHandling: !1
  }, i = function(s) {
    return typeof s == "string" || typeof s == "number" || typeof s == "boolean" || typeof s == "symbol" || typeof s == "bigint";
  }, f = {}, y = function E(s, S, b, R, G, I, B, T, C, w, O, A, k, W, $, Y, z, H, X, Z) {
    var x = s;
    if (Z > X)
      throw new RangeError("Input depth exceeded depth option of " + X);
    for (var q = H, ne = 0, ue = !1; (q = q.get(f)) !== void 0 && !ue; ) {
      var pe = q.get(s);
      if (ne += 1, typeof pe < "u") {
        if (pe === ne)
          throw new RangeError("Cyclic object value");
        ue = !0;
      }
      typeof q.get(f) > "u" && (ne = 0);
    }
    if (x = typeof w == "function" ? w(S, x) : x, x instanceof Date ? x = k(x) : b === "comma" && c(x) && (x = t.maybeMap(x, function(j) {
      return j instanceof Date ? k(j) : j;
    })), x === null) {
      if (I)
        return $(C && !Y ? C(S, a.encoder, z, "key", W) : S);
      x = "";
    }
    if (i(x) || t.isBuffer(x)) {
      if (C) {
        var de = Y ? S : C(S, a.encoder, z, "key", W);
        return [$(de) + "=" + $(C(x, a.encoder, z, "value", W))];
      }
      return [$(S) + "=" + $(String(x))];
    }
    var ie = [];
    if (typeof x > "u")
      return ie;
    var g;
    if (b === "comma" && c(x))
      Y && C && (x = t.maybeMap(x, function(j) {
        return j == null ? j : C(j);
      })), g = [{ value: x.length > 0 ? x.join(",") || null : void 0 }];
    else if (c(w))
      g = w;
    else {
      var N = Object.keys(x);
      g = O ? N.sort(O) : N;
    }
    var _ = T ? String(S).replace(/\./g, "%2E") : String(S), P = R && c(x) && x.length === 1 ? _ + "[]" : _;
    if (G && c(x) && x.length === 0 && Object.keys(x).length === 0)
      return P + "[]";
    for (var D = 0; D < g.length; ++D) {
      var L = g[D], M = typeof L == "object" && L && typeof L.value < "u" ? L.value : x[L];
      if (!(B && M === null)) {
        var F = A && T ? String(L).replace(/\./g, "%2E") : String(L), K = c(x) ? typeof b == "function" ? b(P, F) : P : P + (A ? "." + F : "[" + F + "]");
        H.set(s, ne);
        var ee = e();
        ee.set(f, H), d(ie, E(
          M,
          K,
          b,
          R,
          G,
          I,
          B,
          T,
          b === "comma" && Y && c(x) ? null : C,
          w,
          O,
          A,
          k,
          W,
          $,
          Y,
          z,
          ee,
          X,
          Z + 1
        ));
      }
    }
    return ie;
  }, l = function(s) {
    if (!s)
      return a;
    if (typeof s.allowEmptyArrays < "u" && typeof s.allowEmptyArrays != "boolean")
      throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
    if (typeof s.encodeDotInKeys < "u" && typeof s.encodeDotInKeys != "boolean")
      throw new TypeError("`encodeDotInKeys` option can only be `true` or `false`, when provided");
    if (s.encoder !== null && typeof s.encoder < "u" && typeof s.encoder != "function")
      throw new TypeError("Encoder has to be a function.");
    var S = s.charset || a.charset;
    if (typeof s.charset < "u" && s.charset !== "utf-8" && s.charset !== "iso-8859-1")
      throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var b = r.default;
    if (typeof s.format < "u") {
      if (!n.call(r.formatters, s.format))
        throw new TypeError("Unknown format option provided.");
      b = s.format;
    }
    var R = r.formatters[b], G = a.filter;
    (typeof s.filter == "function" || c(s.filter)) && (G = s.filter);
    var I;
    if (s.arrayFormat in o ? I = s.arrayFormat : "indices" in s ? I = s.indices ? "indices" : "repeat" : I = a.arrayFormat, "commaRoundTrip" in s && typeof s.commaRoundTrip != "boolean")
      throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
    var B = typeof s.allowDots > "u" ? s.encodeDotInKeys === !0 ? !0 : a.allowDots : !!s.allowDots;
    return {
      addQueryPrefix: typeof s.addQueryPrefix == "boolean" ? s.addQueryPrefix : a.addQueryPrefix,
      allowDots: B,
      allowEmptyArrays: typeof s.allowEmptyArrays == "boolean" ? !!s.allowEmptyArrays : a.allowEmptyArrays,
      arrayFormat: I,
      charset: S,
      charsetSentinel: typeof s.charsetSentinel == "boolean" ? s.charsetSentinel : a.charsetSentinel,
      commaRoundTrip: !!s.commaRoundTrip,
      delimiter: typeof s.delimiter > "u" ? a.delimiter : s.delimiter,
      depth: typeof s.depth == "number" ? s.depth : a.depth,
      encode: typeof s.encode == "boolean" ? s.encode : a.encode,
      encodeDotInKeys: typeof s.encodeDotInKeys == "boolean" ? s.encodeDotInKeys : a.encodeDotInKeys,
      encoder: typeof s.encoder == "function" ? s.encoder : a.encoder,
      encodeValuesOnly: typeof s.encodeValuesOnly == "boolean" ? s.encodeValuesOnly : a.encodeValuesOnly,
      filter: G,
      format: b,
      formatter: R,
      serializeDate: typeof s.serializeDate == "function" ? s.serializeDate : a.serializeDate,
      skipNulls: typeof s.skipNulls == "boolean" ? s.skipNulls : a.skipNulls,
      sort: typeof s.sort == "function" ? s.sort : null,
      strictNullHandling: typeof s.strictNullHandling == "boolean" ? s.strictNullHandling : a.strictNullHandling
    };
  };
  return Xt = function(E, s) {
    var S = E, b = l(s), R, G;
    typeof b.filter == "function" ? (G = b.filter, S = G("", S)) : c(b.filter) && (G = b.filter, R = G);
    var I = [];
    if (typeof S != "object" || S === null)
      return "";
    var B = o[b.arrayFormat], T = B === "comma" && b.commaRoundTrip;
    R || (R = Object.keys(S)), b.sort && R.sort(b.sort);
    for (var C = e(), w = 0; w < R.length; ++w) {
      var O = R[w];
      if (!(typeof O > "u" || O === null)) {
        var A = S[O];
        if (!(b.skipNulls && A === null)) {
          var k = b.encodeDotInKeys ? String(O).replace(/\./g, "%2E") : String(O);
          d(I, y(
            A,
            k,
            B,
            T,
            b.allowEmptyArrays,
            b.strictNullHandling,
            b.skipNulls,
            b.encodeDotInKeys,
            b.encode ? b.encoder : null,
            b.filter,
            b.sort,
            b.allowDots,
            b.serializeDate,
            b.format,
            b.formatter,
            b.encodeValuesOnly,
            b.charset,
            C,
            b.depth,
            0
          ));
        }
      }
    }
    var W = I.join(b.delimiter), $ = b.addQueryPrefix === !0 ? "?" : "";
    return b.charsetSentinel && (b.charset === "iso-8859-1" ? $ += "utf8=%26%2310003%3B" + b.delimiter : $ += "utf8=%E2%9C%93" + b.delimiter), W.length > 0 ? $ + W : "";
  }, Xt;
}
var Zt, bn;
function Oa() {
  if (bn) return Zt;
  bn = 1;
  var e = /* @__PURE__ */ lo(), t = Object.prototype.hasOwnProperty, r = Array.isArray, n = {
    allowDots: !1,
    allowEmptyArrays: !1,
    allowPrototypes: !1,
    allowSparse: !1,
    arrayLimit: 20,
    charset: "utf-8",
    charsetSentinel: !1,
    comma: !1,
    decodeDotInKeys: !1,
    decoder: e.decode,
    delimiter: "&",
    depth: 5,
    duplicates: "combine",
    ignoreQueryPrefix: !1,
    interpretNumericEntities: !1,
    parameterLimit: 1e3,
    parseArrays: !0,
    plainObjects: !1,
    strictDepth: !1,
    strictMerge: !0,
    strictNullHandling: !1,
    throwOnLimitExceeded: !1
  }, o = function(y) {
    return y.replace(/&#(\d+);/g, function(l, E) {
      return String.fromCharCode(parseInt(E, 10));
    });
  }, c = function(y, l, E) {
    if (y && typeof y == "string" && l.comma && y.indexOf(",") > -1) {
      if (l.throwOnLimitExceeded)
        for (var s = 0, S = y.indexOf(","); S > -1; ) {
          if (s += 1, s >= l.arrayLimit)
            throw new RangeError("Array limit exceeded. Only " + l.arrayLimit + " element" + (l.arrayLimit === 1 ? "" : "s") + " allowed in an array.");
          S = y.indexOf(",", S + 1);
        }
      return y.split(",");
    }
    if (l.throwOnLimitExceeded && E >= l.arrayLimit)
      throw new RangeError("Array limit exceeded. Only " + l.arrayLimit + " element" + (l.arrayLimit === 1 ? "" : "s") + " allowed in an array.");
    return y;
  }, v = "utf8=%26%2310003%3B", d = "utf8=%E2%9C%93", u = function(l, E) {
    var s = { __proto__: null }, S = E.ignoreQueryPrefix ? l.replace(/^\?/, "") : l;
    S = S.replace(/%5B/gi, "[").replace(/%5D/gi, "]");
    var b = E.parameterLimit === 1 / 0 ? void 0 : E.parameterLimit, R = S.split(
      E.delimiter,
      E.throwOnLimitExceeded && typeof b < "u" ? b + 1 : b
    );
    if (E.throwOnLimitExceeded && typeof b < "u" && R.length > b)
      throw new RangeError("Parameter limit exceeded. Only " + b + " parameter" + (b === 1 ? "" : "s") + " allowed.");
    var G = -1, I, B = E.charset;
    if (E.charsetSentinel)
      for (I = 0; I < R.length; ++I)
        R[I].indexOf("utf8=") === 0 && (R[I] === d ? B = "utf-8" : R[I] === v && (B = "iso-8859-1"), G = I, I = R.length);
    for (I = 0; I < R.length; ++I)
      if (I !== G) {
        var T = R[I], C = T.indexOf("]="), w = C === -1 ? T.indexOf("=") : C + 1, O, A;
        if (w === -1 ? (O = E.decoder(T, n.decoder, B, "key"), A = E.strictNullHandling ? null : "") : (O = E.decoder(T.slice(0, w), n.decoder, B, "key"), O !== null && (A = e.maybeMap(
          c(
            T.slice(w + 1),
            E,
            r(s[O]) ? s[O].length : 0
          ),
          function(W) {
            return E.decoder(W, n.decoder, B, "value");
          }
        ))), A && E.interpretNumericEntities && B === "iso-8859-1" && (A = o(String(A))), T.indexOf("[]=") > -1 && (A = r(A) ? [A] : A), E.comma && r(A) && A.length > E.arrayLimit && (A = e.combine([], A, E.arrayLimit, E.plainObjects, E.throwOnLimitExceeded)), O !== null) {
          var k = t.call(s, O);
          k && (E.duplicates === "combine" || T.indexOf("[]=") > -1) ? s[O] = e.combine(
            s[O],
            A,
            E.arrayLimit,
            E.plainObjects,
            E.throwOnLimitExceeded
          ) : (!k || E.duplicates === "last") && (s[O] = A);
        }
      }
    return s;
  }, p = function(y, l, E, s) {
    var S = 0;
    if (y.length > 0 && y[y.length - 1] === "[]") {
      var b = y.slice(0, -1).join("");
      S = Array.isArray(l) && l[b] ? l[b].length : 0;
    }
    for (var R = s ? l : c(l, E, S), G = y.length - 1; G >= 0; --G) {
      var I, B = y[G];
      if (B === "[]" && E.parseArrays)
        e.isOverflow(R) ? I = R : I = E.allowEmptyArrays && (R === "" || E.strictNullHandling && R === null) ? [] : e.combine(
          [],
          R,
          E.arrayLimit,
          E.plainObjects,
          E.throwOnLimitExceeded
        );
      else {
        I = E.plainObjects ? { __proto__: null } : {};
        var T = B.charAt(0) === "[" && B.charAt(B.length - 1) === "]" ? B.slice(1, -1) : B, C = E.decodeDotInKeys ? T.replace(/%2E/g, ".") : T, w = parseInt(C, 10), O = !isNaN(w) && B !== C && String(w) === C && w >= 0 && E.parseArrays;
        if (!E.parseArrays && C === "")
          I = { 0: R };
        else if (O && w < E.arrayLimit)
          I = [], I[w] = R;
        else {
          if (O && E.throwOnLimitExceeded)
            throw new RangeError("Array limit exceeded. Only " + E.arrayLimit + " element" + (E.arrayLimit === 1 ? "" : "s") + " allowed in an array.");
          O ? (I[w] = R, e.markOverflow(I, w)) : C !== "__proto__" && (I[C] = R);
        }
      }
      R = I;
    }
    return R;
  }, a = function(l, E) {
    var s = E.allowDots ? l.replace(/\.([^.[]+)/g, "[$1]") : l;
    if (E.depth <= 0)
      return !E.plainObjects && t.call(Object.prototype, s) && !E.allowPrototypes ? void 0 : [s];
    var S = [], b = s.indexOf("["), R = b >= 0 ? s.slice(0, b) : s;
    if (R) {
      if (!E.plainObjects && t.call(Object.prototype, R) && !E.allowPrototypes)
        return;
      S[S.length] = R;
    }
    for (var G = s.length, I = b, B = 0; I >= 0 && B < E.depth; ) {
      for (var T = 1, C = I + 1, w = -1; C < G && w < 0; ) {
        var O = s.charCodeAt(C);
        O === 91 ? T += 1 : O === 93 && (T -= 1, T === 0 && (w = C)), C += 1;
      }
      if (w < 0)
        return S[S.length] = "[" + s.slice(I) + "]", S;
      var A = s.slice(I, w + 1), k = A.slice(1, -1);
      if (!E.plainObjects && t.call(Object.prototype, k) && !E.allowPrototypes)
        return;
      S[S.length] = A, B += 1, I = s.indexOf("[", w + 1);
    }
    if (I >= 0) {
      if (E.strictDepth === !0)
        throw new RangeError("Input depth exceeded depth option of " + E.depth + " and strictDepth is true");
      S[S.length] = "[" + s.slice(I) + "]";
    }
    return S;
  }, i = function(l, E, s, S) {
    if (l) {
      var b = a(l, s);
      if (b)
        return p(b, E, s, S);
    }
  }, f = function(l) {
    if (!l)
      return n;
    if (typeof l.allowEmptyArrays < "u" && typeof l.allowEmptyArrays != "boolean")
      throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
    if (typeof l.decodeDotInKeys < "u" && typeof l.decodeDotInKeys != "boolean")
      throw new TypeError("`decodeDotInKeys` option can only be `true` or `false`, when provided");
    if (l.decoder !== null && typeof l.decoder < "u" && typeof l.decoder != "function")
      throw new TypeError("Decoder has to be a function.");
    if (typeof l.charset < "u" && l.charset !== "utf-8" && l.charset !== "iso-8859-1")
      throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    if (typeof l.throwOnLimitExceeded < "u" && typeof l.throwOnLimitExceeded != "boolean")
      throw new TypeError("`throwOnLimitExceeded` option must be a boolean");
    var E = typeof l.charset > "u" ? n.charset : l.charset, s = typeof l.duplicates > "u" ? n.duplicates : l.duplicates;
    if (s !== "combine" && s !== "first" && s !== "last")
      throw new TypeError("The duplicates option must be either combine, first, or last");
    var S = typeof l.allowDots > "u" ? l.decodeDotInKeys === !0 ? !0 : n.allowDots : !!l.allowDots;
    return {
      allowDots: S,
      allowEmptyArrays: typeof l.allowEmptyArrays == "boolean" ? !!l.allowEmptyArrays : n.allowEmptyArrays,
      allowPrototypes: typeof l.allowPrototypes == "boolean" ? l.allowPrototypes : n.allowPrototypes,
      allowSparse: typeof l.allowSparse == "boolean" ? l.allowSparse : n.allowSparse,
      arrayLimit: typeof l.arrayLimit == "number" ? l.arrayLimit : n.arrayLimit,
      charset: E,
      charsetSentinel: typeof l.charsetSentinel == "boolean" ? l.charsetSentinel : n.charsetSentinel,
      comma: typeof l.comma == "boolean" ? l.comma : n.comma,
      decodeDotInKeys: typeof l.decodeDotInKeys == "boolean" ? l.decodeDotInKeys : n.decodeDotInKeys,
      decoder: typeof l.decoder == "function" ? l.decoder : n.decoder,
      delimiter: typeof l.delimiter == "string" || e.isRegExp(l.delimiter) ? l.delimiter : n.delimiter,
      // eslint-disable-next-line no-implicit-coercion, no-extra-parens
      depth: typeof l.depth == "number" || l.depth === !1 ? +l.depth : n.depth,
      duplicates: s,
      ignoreQueryPrefix: l.ignoreQueryPrefix === !0,
      interpretNumericEntities: typeof l.interpretNumericEntities == "boolean" ? l.interpretNumericEntities : n.interpretNumericEntities,
      parameterLimit: typeof l.parameterLimit == "number" ? l.parameterLimit : n.parameterLimit,
      parseArrays: l.parseArrays !== !1,
      plainObjects: typeof l.plainObjects == "boolean" ? l.plainObjects : n.plainObjects,
      strictDepth: typeof l.strictDepth == "boolean" ? !!l.strictDepth : n.strictDepth,
      strictMerge: typeof l.strictMerge == "boolean" ? !!l.strictMerge : n.strictMerge,
      strictNullHandling: typeof l.strictNullHandling == "boolean" ? l.strictNullHandling : n.strictNullHandling,
      throwOnLimitExceeded: typeof l.throwOnLimitExceeded == "boolean" ? l.throwOnLimitExceeded : !1
    };
  };
  return Zt = function(y, l) {
    var E = f(l);
    if (y === "" || y === null || typeof y > "u")
      return E.plainObjects ? { __proto__: null } : {};
    for (var s = typeof y == "string" ? u(y, E) : y, S = E.plainObjects ? { __proto__: null } : {}, b = Object.keys(s), R = 0; R < b.length; ++R) {
      var G = b[R], I = i(G, s[G], E, typeof y == "string");
      S = e.merge(S, I, E);
    }
    return E.allowSparse === !0 ? S : e.compact(S);
  }, Zt;
}
var er, An;
function Sa() {
  if (An) return er;
  An = 1;
  var e = /* @__PURE__ */ Aa(), t = /* @__PURE__ */ Oa(), r = /* @__PURE__ */ vr();
  return er = {
    formats: r,
    parse: t,
    stringify: e
  }, er;
}
var _a = /* @__PURE__ */ Sa();
const Qi = /* @__PURE__ */ Ho(_a);
const Ee = typeof document < "u";
function uo(e) {
  return typeof e == "object" || "displayName" in e || "props" in e || "__vccOpts" in e;
}
function Ra(e) {
  return e.__esModule || e[Symbol.toStringTag] === "Module" || e.default && uo(e.default);
}
const Q = Object.assign;
function tr(e, t) {
  const r = {};
  for (const n in t) {
    const o = t[n];
    r[n] = fe(o) ? o.map(e) : e(o);
  }
  return r;
}
const Ue = () => {
}, fe = Array.isArray;
function On(e, t) {
  const r = {};
  for (const n in e) r[n] = n in t ? t[n] : e[n];
  return r;
}
function V(e) {
  const t = Array.from(arguments).slice(1);
  console.warn.apply(console, ["[Vue Router warn]: " + e].concat(t));
}
const co = /#/g, Pa = /&/g, Na = /\//g, Ia = /=/g, Ca = /\?/g, so = /\+/g, xa = /%5B/g, Da = /%5D/g, fo = /%5E/g, Ta = /%60/g, po = /%7B/g, Ma = /%7C/g, yo = /%7D/g, Fa = /%20/g;
function mr(e) {
  return e == null ? "" : encodeURI("" + e).replace(Ma, "|").replace(xa, "[").replace(Da, "]");
}
function qa(e) {
  return mr(e).replace(po, "{").replace(yo, "}").replace(fo, "^");
}
function lr(e) {
  return mr(e).replace(so, "%2B").replace(Fa, "+").replace(co, "%23").replace(Pa, "%26").replace(Ta, "`").replace(po, "{").replace(yo, "}").replace(fo, "^");
}
function ka(e) {
  return lr(e).replace(Ia, "%3D");
}
function La(e) {
  return mr(e).replace(co, "%23").replace(Ca, "%3F");
}
function $a(e) {
  return La(e).replace(Na, "%2F");
}
function qe(e) {
  if (e == null) return null;
  try {
    return decodeURIComponent("" + e);
  } catch {
    process.env.NODE_ENV !== "production" && V(`Error decoding "${e}". Using original value`);
  }
  return "" + e;
}
const Ba = /\/$/, Ga = (e) => e.replace(Ba, "");
function rr(e, t, r = "/") {
  let n, o = {}, c = "", v = "";
  const d = t.indexOf("#");
  let u = t.indexOf("?");
  return u = d >= 0 && u > d ? -1 : u, u >= 0 && (n = t.slice(0, u), c = t.slice(u, d > 0 ? d : t.length), o = e(c.slice(1))), d >= 0 && (n = n || t.slice(0, d), v = t.slice(d, t.length)), n = ja(n ?? t, r), {
    fullPath: n + c + v,
    path: n,
    query: o,
    hash: qe(v)
  };
}
function Va(e, t) {
  const r = t.query ? e(t.query) : "";
  return t.path + (r && "?") + r + (t.hash || "");
}
function Sn(e, t) {
  return !t || !e.toLowerCase().startsWith(t.toLowerCase()) ? e : e.slice(t.length) || "/";
}
function _n(e, t, r) {
  const n = t.matched.length - 1, o = r.matched.length - 1;
  return n > -1 && n === o && Re(t.matched[n], r.matched[o]) && ho(t.params, r.params) && e(t.query) === e(r.query) && t.hash === r.hash;
}
function Re(e, t) {
  return (e.aliasOf || e) === (t.aliasOf || t);
}
function ho(e, t) {
  if (Object.keys(e).length !== Object.keys(t).length) return !1;
  for (var r in e) if (!Ua(e[r], t[r])) return !1;
  return !0;
}
function Ua(e, t) {
  return fe(e) ? Rn(e, t) : fe(t) ? Rn(t, e) : e?.valueOf() === t?.valueOf();
}
function Rn(e, t) {
  return fe(t) ? e.length === t.length && e.every((r, n) => r === t[n]) : e.length === 1 && e[0] === t;
}
function ja(e, t) {
  if (e.startsWith("/")) return e;
  if (process.env.NODE_ENV !== "production" && !t.startsWith("/"))
    return V(`Cannot resolve a relative location without an absolute path. Trying to resolve "${e}" from "${t}". It should look like "/${t}".`), e;
  if (!e) return t;
  const r = t.split("/"), n = e.split("/"), o = n[n.length - 1];
  (o === ".." || o === ".") && n.push("");
  let c = r.length - 1, v, d;
  for (v = 0; v < n.length; v++)
    if (d = n[v], d !== ".")
      if (d === "..")
        c > 1 && c--;
      else break;
  return r.slice(0, c).join("/") + "/" + n.slice(v).join("/");
}
const Se = {
  path: "/",
  name: void 0,
  params: {},
  query: {},
  hash: "",
  fullPath: "/",
  matched: [],
  meta: {},
  redirectedFrom: void 0
};
let ur = /* @__PURE__ */ (function(e) {
  return e.pop = "pop", e.push = "push", e;
})({}), nr = /* @__PURE__ */ (function(e) {
  return e.back = "back", e.forward = "forward", e.unknown = "", e;
})({});
function Wa(e) {
  if (!e) if (Ee) {
    const t = document.querySelector("base");
    e = t && t.getAttribute("href") || "/", e = e.replace(/^\w+:\/\/[^\/]+/, "");
  } else e = "/";
  return e[0] !== "/" && e[0] !== "#" && (e = "/" + e), Ga(e);
}
const Ha = /^[^#]+#/;
function Ka(e, t) {
  return e.replace(Ha, "#") + t;
}
function za(e, t) {
  const r = document.documentElement.getBoundingClientRect(), n = e.getBoundingClientRect();
  return {
    behavior: t.behavior,
    left: n.left - r.left - (t.left || 0),
    top: n.top - r.top - (t.top || 0)
  };
}
const Ze = () => ({
  left: window.scrollX,
  top: window.scrollY
});
function Qa(e) {
  let t;
  if ("el" in e) {
    const r = e.el, n = typeof r == "string" && r.startsWith("#");
    if (process.env.NODE_ENV !== "production" && typeof e.el == "string" && (!n || !document.getElementById(e.el.slice(1))))
      try {
        const c = document.querySelector(e.el);
        if (n && c) {
          V(`The selector "${e.el}" should be passed as "el: document.querySelector('${e.el}')" because it starts with "#".`);
          return;
        }
      } catch {
        V(`The selector "${e.el}" is invalid. If you are using an id selector, make sure to escape it. You can find more information about escaping characters in selectors at https://mathiasbynens.be/notes/css-escapes or use CSS.escape (https://developer.mozilla.org/en-US/docs/Web/API/CSS/escape).`);
        return;
      }
    const o = typeof r == "string" ? n ? document.getElementById(r.slice(1)) : document.querySelector(r) : r;
    if (!o) {
      process.env.NODE_ENV !== "production" && V(`Couldn't find element using selector "${e.el}" returned by scrollBehavior.`);
      return;
    }
    t = za(o, e);
  } else t = e;
  "scrollBehavior" in document.documentElement.style ? window.scrollTo(t) : window.scrollTo(t.left != null ? t.left : window.scrollX, t.top != null ? t.top : window.scrollY);
}
function Pn(e, t) {
  return (history.state ? history.state.position - t : -1) + e;
}
const cr = /* @__PURE__ */ new Map();
function Ja(e, t) {
  cr.set(e, t);
}
function Ya(e) {
  const t = cr.get(e);
  return cr.delete(e), t;
}
function Je(e) {
  return typeof e == "string" || e && typeof e == "object";
}
function vo(e) {
  return typeof e == "string" || typeof e == "symbol";
}
let ae = /* @__PURE__ */ (function(e) {
  return e[e.MATCHER_NOT_FOUND = 1] = "MATCHER_NOT_FOUND", e[e.NAVIGATION_GUARD_REDIRECT = 2] = "NAVIGATION_GUARD_REDIRECT", e[e.NAVIGATION_ABORTED = 4] = "NAVIGATION_ABORTED", e[e.NAVIGATION_CANCELLED = 8] = "NAVIGATION_CANCELLED", e[e.NAVIGATION_DUPLICATED = 16] = "NAVIGATION_DUPLICATED", e;
})({});
const sr = /* @__PURE__ */ Symbol(process.env.NODE_ENV !== "production" ? "navigation failure" : ""), Xa = {
  [ae.MATCHER_NOT_FOUND]({ location: e, currentLocation: t }) {
    return `No match for
 ${JSON.stringify(e)}${t ? `
while being at
` + JSON.stringify(t) : ""}`;
  },
  [ae.NAVIGATION_GUARD_REDIRECT]({ from: e, to: t }) {
    return `Redirected from "${e.fullPath}" to "${ei(t)}" via a navigation guard.`;
  },
  [ae.NAVIGATION_ABORTED]({ from: e, to: t }) {
    return `Navigation aborted from "${e.fullPath}" to "${t.fullPath}" via a navigation guard.`;
  },
  [ae.NAVIGATION_CANCELLED]({ from: e, to: t }) {
    return `Navigation cancelled from "${e.fullPath}" to "${t.fullPath}" with a new navigation.`;
  },
  [ae.NAVIGATION_DUPLICATED]({ from: e, to: t }) {
    return `Avoided redundant navigation to current location: "${e.fullPath}".`;
  }
};
function ke(e, t) {
  return process.env.NODE_ENV !== "production" ? Q(new Error(Xa[e](t)), {
    type: e,
    [sr]: !0
  }, t) : Q(/* @__PURE__ */ new Error(), {
    type: e,
    [sr]: !0
  }, t);
}
function ge(e, t) {
  return e instanceof Error && sr in e && (t == null || !!(e.type & t));
}
const Za = [
  "params",
  "query",
  "hash"
];
function ei(e) {
  if (typeof e == "string") return e;
  if (e.path != null) return e.path;
  const t = {};
  for (const r of Za) r in e && (t[r] = e[r]);
  return JSON.stringify(t, null, 2);
}
function ti(e) {
  const t = {};
  if (e === "" || e === "?") return t;
  const r = (e[0] === "?" ? e.slice(1) : e).split("&");
  for (let n = 0; n < r.length; ++n) {
    const o = r[n].replace(so, " "), c = o.indexOf("="), v = qe(c < 0 ? o : o.slice(0, c)), d = c < 0 ? null : qe(o.slice(c + 1));
    if (v in t) {
      let u = t[v];
      fe(u) || (u = t[v] = [u]), u.push(d);
    } else t[v] = d;
  }
  return t;
}
function Nn(e) {
  let t = "";
  for (let r in e) {
    const n = e[r];
    if (r = ka(r), n == null) {
      n !== void 0 && (t += (t.length ? "&" : "") + r);
      continue;
    }
    (fe(n) ? n.map((o) => o && lr(o)) : [n && lr(n)]).forEach((o) => {
      o !== void 0 && (t += (t.length ? "&" : "") + r, o != null && (t += "=" + o));
    });
  }
  return t;
}
function ri(e) {
  const t = {};
  for (const r in e) {
    const n = e[r];
    n !== void 0 && (t[r] = fe(n) ? n.map((o) => o == null ? null : "" + o) : n == null ? n : "" + n);
  }
  return t;
}
const ni = /* @__PURE__ */ Symbol(process.env.NODE_ENV !== "production" ? "router view location matched" : ""), In = /* @__PURE__ */ Symbol(process.env.NODE_ENV !== "production" ? "router view depth" : ""), gr = /* @__PURE__ */ Symbol(process.env.NODE_ENV !== "production" ? "router" : ""), mo = /* @__PURE__ */ Symbol(process.env.NODE_ENV !== "production" ? "route location" : ""), fr = /* @__PURE__ */ Symbol(process.env.NODE_ENV !== "production" ? "router view location" : "");
function Ge() {
  let e = [];
  function t(n) {
    return e.push(n), () => {
      const o = e.indexOf(n);
      o > -1 && e.splice(o, 1);
    };
  }
  function r() {
    e = [];
  }
  return {
    add: t,
    list: () => e.slice(),
    reset: r
  };
}
function _e(e, t, r, n, o, c = (v) => v()) {
  const v = n && (n.enterCallbacks[o] = n.enterCallbacks[o] || []);
  return () => new Promise((d, u) => {
    const p = (f) => {
      f === !1 ? u(ke(ae.NAVIGATION_ABORTED, {
        from: r,
        to: t
      })) : f instanceof Error ? u(f) : Je(f) ? u(ke(ae.NAVIGATION_GUARD_REDIRECT, {
        from: t,
        to: f
      })) : (v && n.enterCallbacks[o] === v && typeof f == "function" && v.push(f), d());
    }, a = c(() => e.call(n && n.instances[o], t, r, process.env.NODE_ENV !== "production" ? oi(p, t, r) : p));
    let i = Promise.resolve(a);
    if (e.length < 3 && (i = i.then(p)), process.env.NODE_ENV !== "production" && e.length > 2) {
      const f = `The "next" callback was never called inside of ${e.name ? '"' + e.name + '"' : ""}:
${e.toString()}
. If you are returning a value instead of calling "next", make sure to remove the "next" parameter from your function.`;
      if (typeof a == "object" && "then" in a) i = i.then((y) => p._called ? y : (V(f), Promise.reject(/* @__PURE__ */ new Error("Invalid navigation guard"))));
      else if (a !== void 0 && !p._called) {
        V(f), u(/* @__PURE__ */ new Error("Invalid navigation guard"));
        return;
      }
    }
    i.catch((f) => u(f));
  });
}
function oi(e, t, r) {
  let n = 0;
  return function() {
    n++ === 1 && V(`The "next" callback was called more than once in one navigation guard when going from "${r.fullPath}" to "${t.fullPath}". It should be called exactly one time in each navigation guard. This will fail in production.`), e._called = !0, n === 1 && e.apply(null, arguments);
  };
}
function or(e, t, r, n, o = (c) => c()) {
  const c = [];
  for (const v of e) {
    process.env.NODE_ENV !== "production" && !v.components && v.children && !v.children.length && V(`Record with path "${v.path}" is either missing a "component(s)" or "children" property.`);
    for (const d in v.components) {
      let u = v.components[d];
      if (process.env.NODE_ENV !== "production") {
        if (!u || typeof u != "object" && typeof u != "function")
          throw V(`Component "${d}" in record with path "${v.path}" is not a valid component. Received "${String(u)}".`), new Error("Invalid route component");
        if ("then" in u) {
          V(`Component "${d}" in record with path "${v.path}" is a Promise instead of a function that returns a Promise. Did you write "import('./MyPage.vue')" instead of "() => import('./MyPage.vue')" ? This will break in production if not fixed.`);
          const p = u;
          u = () => p;
        } else u.__asyncLoader && !u.__warnedDefineAsync && (u.__warnedDefineAsync = !0, V(`Component "${d}" in record with path "${v.path}" is defined using "defineAsyncComponent()". Write "() => import('./MyPage.vue')" instead of "defineAsyncComponent(() => import('./MyPage.vue'))".`));
      }
      if (!(t !== "beforeRouteEnter" && !v.instances[d]))
        if (uo(u)) {
          const p = (u.__vccOpts || u)[t];
          p && c.push(_e(p, r, n, v, d, o));
        } else {
          let p = u();
          process.env.NODE_ENV !== "production" && !("catch" in p) && (V(`Component "${d}" in record with path "${v.path}" is a function that does not return a Promise. If you were passing a functional component, make sure to add a "displayName" to the component. This will break in production if not fixed.`), p = Promise.resolve(p)), c.push(() => p.then((a) => {
            if (!a) throw new Error(`Couldn't resolve component "${d}" at "${v.path}"`);
            const i = Ra(a) ? a.default : a;
            v.mods[d] = a, v.components[d] = i;
            const f = (i.__vccOpts || i)[t];
            return f && _e(f, r, n, v, d, o)();
          }));
        }
    }
  }
  return c;
}
function ai(e, t) {
  const r = [], n = [], o = [], c = Math.max(t.matched.length, e.matched.length);
  for (let v = 0; v < c; v++) {
    const d = t.matched[v];
    d && (e.matched.find((p) => Re(p, d)) ? n.push(d) : r.push(d));
    const u = e.matched[v];
    u && (t.matched.find((p) => Re(p, u)) || o.push(u));
  }
  return [
    r,
    n,
    o
  ];
}
function Ve(e, t) {
  const r = Q({}, e, { matched: e.matched.map((n) => vi(n, [
    "instances",
    "children",
    "aliasOf"
  ])) });
  return { _custom: {
    type: null,
    readOnly: !0,
    display: e.fullPath,
    tooltip: t,
    value: r
  } };
}
function Qe(e) {
  return { _custom: { display: e } };
}
let ii = 0;
function li(e, t, r) {
  if (t.__hasDevtools) return;
  t.__hasDevtools = !0;
  const n = ii++;
  Fo({
    id: "org.vuejs.router" + (n ? "." + n : ""),
    label: "Vue Router",
    packageName: "vue-router",
    homepage: "https://router.vuejs.org",
    logo: "https://router.vuejs.org/logo.png",
    componentStateTypes: ["Routing"],
    app: e
  }, (o) => {
    typeof o.now != "function" && V("[Vue Router]: You seem to be using an outdated version of Vue Devtools. Are you still using the Beta release instead of the stable one? You can find the links at https://devtools.vuejs.org/guide/installation.html."), o.on.inspectComponent((a, i) => {
      a.instanceData && a.instanceData.state.push({
        type: "Routing",
        key: "$route",
        editable: !1,
        value: Ve(t.currentRoute.value, "Current Route")
      });
    }), o.on.visitComponentTree(({ treeNode: a, componentInstance: i }) => {
      if (i.__vrv_devtools) {
        const f = i.__vrv_devtools;
        a.tags.push({
          label: (f.name ? `${f.name.toString()}: ` : "") + f.path,
          textColor: 0,
          tooltip: "This component is rendered by &lt;router-view&gt;",
          backgroundColor: go
        });
      }
      fe(i.__vrl_devtools) && (i.__devtoolsApi = o, i.__vrl_devtools.forEach((f) => {
        let y = f.route.path, l = bo, E = "", s = 0;
        f.error ? (y = f.error, l = pi, s = di) : f.isExactActive ? (l = wo, E = "This is exactly active") : f.isActive && (l = Eo, E = "This link is active"), a.tags.push({
          label: y,
          textColor: s,
          tooltip: E,
          backgroundColor: l
        });
      }));
    }), Bn(t.currentRoute, () => {
      u(), o.notifyComponentUpdate(), o.sendInspectorTree(d), o.sendInspectorState(d);
    });
    const c = "router:navigations:" + n;
    o.addTimelineLayer({
      id: c,
      label: `Router${n ? " " + n : ""} Navigations`,
      color: 4237508
    }), t.onError((a, i) => {
      o.addTimelineEvent({
        layerId: c,
        event: {
          title: "Error during Navigation",
          subtitle: i.fullPath,
          logType: "error",
          time: o.now(),
          data: { error: a },
          groupId: i.meta.__navigationId
        }
      });
    });
    let v = 0;
    t.beforeEach((a, i) => {
      const f = {
        guard: Qe("beforeEach"),
        from: Ve(i, "Current Location during this navigation"),
        to: Ve(a, "Target location")
      };
      Object.defineProperty(a.meta, "__navigationId", { value: v++ }), o.addTimelineEvent({
        layerId: c,
        event: {
          time: o.now(),
          title: "Start of navigation",
          subtitle: a.fullPath,
          data: f,
          groupId: a.meta.__navigationId
        }
      });
    }), t.afterEach((a, i, f) => {
      const y = { guard: Qe("afterEach") };
      f ? (y.failure = { _custom: {
        type: Error,
        readOnly: !0,
        display: f ? f.message : "",
        tooltip: "Navigation Failure",
        value: f
      } }, y.status = Qe("❌")) : y.status = Qe("✅"), y.from = Ve(i, "Current Location during this navigation"), y.to = Ve(a, "Target location"), o.addTimelineEvent({
        layerId: c,
        event: {
          title: "End of navigation",
          subtitle: a.fullPath,
          time: o.now(),
          data: y,
          logType: f ? "warning" : "default",
          groupId: a.meta.__navigationId
        }
      });
    });
    const d = "router-inspector:" + n;
    o.addInspector({
      id: d,
      label: "Routes" + (n ? " " + n : ""),
      icon: "book",
      treeFilterPlaceholder: "Search routes"
    });
    function u() {
      if (!p) return;
      const a = p;
      let i = r.getRoutes().filter((f) => !f.parent || !f.parent.record.components);
      i.forEach(So), a.filter && (i = i.filter((f) => pr(f, a.filter.toLowerCase()))), i.forEach((f) => Oo(f, t.currentRoute.value)), a.rootNodes = i.map(Ao);
    }
    let p;
    o.on.getInspectorTree((a) => {
      p = a, a.app === e && a.inspectorId === d && u();
    }), o.on.getInspectorState((a) => {
      if (a.app === e && a.inspectorId === d) {
        const i = r.getRoutes().find((f) => f.record.__vd_id === a.nodeId);
        i && (a.state = { options: ci(i) });
      }
    }), o.sendInspectorTree(d), o.sendInspectorState(d);
  });
}
function ui(e) {
  return e.optional ? e.repeatable ? "*" : "?" : e.repeatable ? "+" : "";
}
function ci(e) {
  const { record: t } = e, r = [{
    editable: !1,
    key: "path",
    value: t.path
  }];
  return t.name != null && r.push({
    editable: !1,
    key: "name",
    value: t.name
  }), r.push({
    editable: !1,
    key: "regexp",
    value: e.re
  }), e.keys.length && r.push({
    editable: !1,
    key: "keys",
    value: { _custom: {
      type: null,
      readOnly: !0,
      display: e.keys.map((n) => `${n.name}${ui(n)}`).join(" "),
      tooltip: "Param keys",
      value: e.keys
    } }
  }), t.redirect != null && r.push({
    editable: !1,
    key: "redirect",
    value: t.redirect
  }), e.alias.length && r.push({
    editable: !1,
    key: "aliases",
    value: e.alias.map((n) => n.record.path)
  }), Object.keys(e.record.meta).length && r.push({
    editable: !1,
    key: "meta",
    value: e.record.meta
  }), r.push({
    key: "score",
    editable: !1,
    value: { _custom: {
      type: null,
      readOnly: !0,
      display: e.score.map((n) => n.join(", ")).join(" | "),
      tooltip: "Score used to sort routes",
      value: e.score
    } }
  }), r;
}
const go = 15485081, Eo = 2450411, wo = 8702998, si = 2282478, bo = 16486972, fi = 6710886, pi = 16704226, di = 12131356;
function Ao(e) {
  const t = [], { record: r } = e;
  r.name != null && t.push({
    label: String(r.name),
    textColor: 0,
    backgroundColor: si
  }), r.aliasOf && t.push({
    label: "alias",
    textColor: 0,
    backgroundColor: bo
  }), e.__vd_match && t.push({
    label: "matches",
    textColor: 0,
    backgroundColor: go
  }), e.__vd_exactActive && t.push({
    label: "exact",
    textColor: 0,
    backgroundColor: wo
  }), e.__vd_active && t.push({
    label: "active",
    textColor: 0,
    backgroundColor: Eo
  }), r.redirect && t.push({
    label: typeof r.redirect == "string" ? `redirect: ${r.redirect}` : "redirects",
    textColor: 16777215,
    backgroundColor: fi
  });
  let n = r.__vd_id;
  return n == null && (n = String(yi++), r.__vd_id = n), {
    id: n,
    label: r.path,
    tags: t,
    children: e.children.map(Ao)
  };
}
let yi = 0;
const hi = /^\/(.*)\/([a-z]*)$/;
function Oo(e, t) {
  const r = t.matched.length && Re(t.matched[t.matched.length - 1], e.record);
  e.__vd_exactActive = e.__vd_active = r, r || (e.__vd_active = t.matched.some((n) => Re(n, e.record))), e.children.forEach((n) => Oo(n, t));
}
function So(e) {
  e.__vd_match = !1, e.children.forEach(So);
}
function pr(e, t) {
  const r = String(e.re).match(hi);
  if (e.__vd_match = !1, !r || r.length < 3) return !1;
  if (new RegExp(r[1].replace(/\$$/, ""), r[2]).test(t))
    return e.children.forEach((c) => pr(c, t)), e.record.path !== "/" || t === "/" ? (e.__vd_match = e.re.test(t), !0) : !1;
  const n = e.record.path.toLowerCase(), o = qe(n);
  return !t.startsWith("/") && (o.includes(t) || n.includes(t)) || o.startsWith(t) || n.startsWith(t) || e.record.name && String(e.record.name).includes(t) ? !0 : e.children.some((c) => pr(c, t));
}
function vi(e, t) {
  const r = {};
  for (const n in e) t.includes(n) || (r[n] = e[n]);
  return r;
}
let mi = () => location.protocol + "//" + location.host;
function _o(e, t) {
  const { pathname: r, search: n, hash: o } = t, c = e.indexOf("#");
  if (c > -1) {
    let v = o.includes(e.slice(c)) ? e.slice(c).length : 1, d = o.slice(v);
    return d[0] !== "/" && (d = "/" + d), Sn(d, "");
  }
  return Sn(r, e) + n + o;
}
function gi(e, t, r, n) {
  let o = [], c = [], v = null;
  const d = ({ state: f }) => {
    const y = _o(e, location), l = r.value, E = t.value;
    let s = 0;
    if (f) {
      if (r.value = y, t.value = f, v && v === l) {
        v = null;
        return;
      }
      s = E ? f.position - E.position : 0;
    } else n(y);
    o.forEach((S) => {
      S(r.value, l, {
        delta: s,
        type: ur.pop,
        direction: s ? s > 0 ? nr.forward : nr.back : nr.unknown
      });
    });
  };
  function u() {
    v = r.value;
  }
  function p(f) {
    o.push(f);
    const y = () => {
      const l = o.indexOf(f);
      l > -1 && o.splice(l, 1);
    };
    return c.push(y), y;
  }
  function a() {
    if (document.visibilityState === "hidden") {
      const { history: f } = window;
      if (!f.state) return;
      f.replaceState(Q({}, f.state, { scroll: Ze() }), "");
    }
  }
  function i() {
    for (const f of c) f();
    c = [], window.removeEventListener("popstate", d), window.removeEventListener("pagehide", a), document.removeEventListener("visibilitychange", a);
  }
  return window.addEventListener("popstate", d), window.addEventListener("pagehide", a), document.addEventListener("visibilitychange", a), {
    pauseListeners: u,
    listen: p,
    destroy: i
  };
}
function Cn(e, t, r, n = !1, o = !1) {
  return {
    back: e,
    current: t,
    forward: r,
    replaced: n,
    position: window.history.length,
    scroll: o ? Ze() : null
  };
}
function Ei(e) {
  const { history: t, location: r } = window, n = { value: _o(e, r) }, o = { value: t.state };
  o.value || c(n.value, {
    back: null,
    current: n.value,
    forward: null,
    position: t.length - 1,
    replaced: !0,
    scroll: null
  }, !0);
  function c(u, p, a) {
    const i = e.indexOf("#"), f = i > -1 ? (r.host && document.querySelector("base") ? e : e.slice(i)) + u : mi() + e + u;
    try {
      t[a ? "replaceState" : "pushState"](p, "", f), o.value = p;
    } catch (y) {
      process.env.NODE_ENV !== "production" ? V("Error with push/replace State", y) : console.error(y), r[a ? "replace" : "assign"](f);
    }
  }
  function v(u, p) {
    c(u, Q({}, t.state, Cn(o.value.back, u, o.value.forward, !0), p, { position: o.value.position }), !0), n.value = u;
  }
  function d(u, p) {
    const a = Q({}, o.value, t.state, {
      forward: u,
      scroll: Ze()
    });
    process.env.NODE_ENV !== "production" && !t.state && V(`history.state seems to have been manually replaced without preserving the necessary values. Make sure to preserve existing history state if you are manually calling history.replaceState:

history.replaceState(history.state, '', url)

You can find more information at https://router.vuejs.org/guide/migration/#Usage-of-history-state`), c(a.current, a, !0), c(u, Q({}, Cn(n.value, u, null), { position: a.position + 1 }, p), !1), n.value = u;
  }
  return {
    location: n,
    state: o,
    push: d,
    replace: v
  };
}
function Ji(e) {
  e = Wa(e);
  const t = Ei(e), r = gi(e, t.state, t.location, t.replace);
  function n(c, v = !0) {
    v || r.pauseListeners(), history.go(c);
  }
  const o = Q({
    location: "",
    base: e,
    go: n,
    createHref: Ka.bind(null, e)
  }, t, r);
  return Object.defineProperty(o, "location", {
    enumerable: !0,
    get: () => t.location.value
  }), Object.defineProperty(o, "state", {
    enumerable: !0,
    get: () => t.state.value
  }), o;
}
let Ne = /* @__PURE__ */ (function(e) {
  return e[e.Static = 0] = "Static", e[e.Param = 1] = "Param", e[e.Group = 2] = "Group", e;
})({});
var le = /* @__PURE__ */ (function(e) {
  return e[e.Static = 0] = "Static", e[e.Param = 1] = "Param", e[e.ParamRegExp = 2] = "ParamRegExp", e[e.ParamRegExpEnd = 3] = "ParamRegExpEnd", e[e.EscapeNext = 4] = "EscapeNext", e;
})(le || {});
const wi = {
  type: Ne.Static,
  value: ""
}, bi = /[a-zA-Z0-9_]/;
function Ai(e) {
  if (!e) return [[]];
  if (e === "/") return [[wi]];
  if (!e.startsWith("/")) throw new Error(process.env.NODE_ENV !== "production" ? `Route paths should start with a "/": "${e}" should be "/${e}".` : `Invalid path "${e}"`);
  function t(y) {
    throw new Error(`ERR (${r})/"${p}": ${y}`);
  }
  let r = le.Static, n = r;
  const o = [];
  let c;
  function v() {
    c && o.push(c), c = [];
  }
  let d = 0, u, p = "", a = "";
  function i() {
    p && (r === le.Static ? c.push({
      type: Ne.Static,
      value: p
    }) : r === le.Param || r === le.ParamRegExp || r === le.ParamRegExpEnd ? (c.length > 1 && (u === "*" || u === "+") && t(`A repeatable param (${p}) must be alone in its segment. eg: '/:ids+.`), c.push({
      type: Ne.Param,
      value: p,
      regexp: a,
      repeatable: u === "*" || u === "+",
      optional: u === "*" || u === "?"
    })) : t("Invalid state to consume buffer"), p = "");
  }
  function f() {
    p += u;
  }
  for (; d < e.length; ) {
    if (u = e[d++], u === "\\" && r !== le.ParamRegExp) {
      n = r, r = le.EscapeNext;
      continue;
    }
    switch (r) {
      case le.Static:
        u === "/" ? (p && i(), v()) : u === ":" ? (i(), r = le.Param) : f();
        break;
      case le.EscapeNext:
        f(), r = n;
        break;
      case le.Param:
        u === "(" ? r = le.ParamRegExp : bi.test(u) ? f() : (i(), r = le.Static, u !== "*" && u !== "?" && u !== "+" && d--);
        break;
      case le.ParamRegExp:
        u === ")" ? a[a.length - 1] == "\\" ? a = a.slice(0, -1) + u : r = le.ParamRegExpEnd : a += u;
        break;
      case le.ParamRegExpEnd:
        i(), r = le.Static, u !== "*" && u !== "?" && u !== "+" && d--, a = "";
        break;
      default:
        t("Unknown state");
        break;
    }
  }
  return r === le.ParamRegExp && t(`Unfinished custom RegExp for param "${p}"`), i(), v(), o;
}
const xn = "[^/]+?", Oi = {
  sensitive: !1,
  strict: !1,
  start: !0,
  end: !0
};
var ce = /* @__PURE__ */ (function(e) {
  return e[e._multiplier = 10] = "_multiplier", e[e.Root = 90] = "Root", e[e.Segment = 40] = "Segment", e[e.SubSegment = 30] = "SubSegment", e[e.Static = 40] = "Static", e[e.Dynamic = 20] = "Dynamic", e[e.BonusCustomRegExp = 10] = "BonusCustomRegExp", e[e.BonusWildcard = -50] = "BonusWildcard", e[e.BonusRepeatable = -20] = "BonusRepeatable", e[e.BonusOptional = -8] = "BonusOptional", e[e.BonusStrict = 0.7000000000000001] = "BonusStrict", e[e.BonusCaseSensitive = 0.25] = "BonusCaseSensitive", e;
})(ce || {});
const Si = /[.+*?^${}()[\]/\\]/g;
function _i(e, t) {
  const r = Q({}, Oi, t), n = [];
  let o = r.start ? "^" : "";
  const c = [];
  for (const p of e) {
    const a = p.length ? [] : [ce.Root];
    r.strict && !p.length && (o += "/");
    for (let i = 0; i < p.length; i++) {
      const f = p[i];
      let y = ce.Segment + (r.sensitive ? ce.BonusCaseSensitive : 0);
      if (f.type === Ne.Static)
        i || (o += "/"), o += f.value.replace(Si, "\\$&"), y += ce.Static;
      else if (f.type === Ne.Param) {
        const { value: l, repeatable: E, optional: s, regexp: S } = f;
        c.push({
          name: l,
          repeatable: E,
          optional: s
        });
        const b = S || xn;
        if (b !== xn) {
          y += ce.BonusCustomRegExp;
          try {
            `${b}`;
          } catch (G) {
            throw new Error(`Invalid custom RegExp for param "${l}" (${b}): ` + G.message);
          }
        }
        let R = E ? `((?:${b})(?:/(?:${b}))*)` : `(${b})`;
        i || (R = s && p.length < 2 ? `(?:/${R})` : "/" + R), s && (R += "?"), o += R, y += ce.Dynamic, s && (y += ce.BonusOptional), E && (y += ce.BonusRepeatable), b === ".*" && (y += ce.BonusWildcard);
      }
      a.push(y);
    }
    n.push(a);
  }
  if (r.strict && r.end) {
    const p = n.length - 1;
    n[p][n[p].length - 1] += ce.BonusStrict;
  }
  r.strict || (o += "/?"), r.end ? o += "$" : r.strict && !o.endsWith("/") && (o += "(?:/|$)");
  const v = new RegExp(o, r.sensitive ? "" : "i");
  function d(p) {
    const a = p.match(v), i = {};
    if (!a) return null;
    for (let f = 1; f < a.length; f++) {
      const y = a[f] || "", l = c[f - 1];
      i[l.name] = y && l.repeatable ? y.split("/") : y;
    }
    return i;
  }
  function u(p) {
    let a = "", i = !1;
    for (const f of e) {
      (!i || !a.endsWith("/")) && (a += "/"), i = !1;
      for (const y of f) if (y.type === Ne.Static) a += y.value;
      else if (y.type === Ne.Param) {
        const { value: l, repeatable: E, optional: s } = y, S = l in p ? p[l] : "";
        if (fe(S) && !E) throw new Error(`Provided param "${l}" is an array but it is not repeatable (* or + modifiers)`);
        const b = fe(S) ? S.join("/") : S;
        if (!b) if (s)
          f.length < 2 && (a.endsWith("/") ? a = a.slice(0, -1) : i = !0);
        else throw new Error(`Missing required param "${l}"`);
        a += b;
      }
    }
    return a || "/";
  }
  return {
    re: v,
    score: n,
    keys: c,
    parse: d,
    stringify: u
  };
}
function Ri(e, t) {
  let r = 0;
  for (; r < e.length && r < t.length; ) {
    const n = t[r] - e[r];
    if (n) return n;
    r++;
  }
  return e.length < t.length ? e.length === 1 && e[0] === ce.Static + ce.Segment ? -1 : 1 : e.length > t.length ? t.length === 1 && t[0] === ce.Static + ce.Segment ? 1 : -1 : 0;
}
function Ro(e, t) {
  let r = 0;
  const n = e.score, o = t.score;
  for (; r < n.length && r < o.length; ) {
    const c = Ri(n[r], o[r]);
    if (c) return c;
    r++;
  }
  if (Math.abs(o.length - n.length) === 1) {
    if (Dn(n)) return 1;
    if (Dn(o)) return -1;
  }
  return o.length - n.length;
}
function Dn(e) {
  const t = e[e.length - 1];
  return e.length > 0 && t[t.length - 1] < 0;
}
const Pi = {
  strict: !1,
  end: !0,
  sensitive: !1
};
function Ni(e, t, r) {
  const n = _i(Ai(e.path), r);
  if (process.env.NODE_ENV !== "production") {
    const c = /* @__PURE__ */ new Set();
    for (const v of n.keys)
      c.has(v.name) && V(`Found duplicated params with name "${v.name}" for path "${e.path}". Only the last one will be available on "$route.params".`), c.add(v.name);
  }
  const o = Q(n, {
    record: e,
    parent: t,
    children: [],
    alias: []
  });
  return t && !o.record.aliasOf == !t.record.aliasOf && t.children.push(o), o;
}
function Ii(e, t) {
  const r = [], n = /* @__PURE__ */ new Map();
  t = On(Pi, t);
  function o(i) {
    return n.get(i);
  }
  function c(i, f, y) {
    const l = !y, E = Mn(i);
    process.env.NODE_ENV !== "production" && Ti(E, f), E.aliasOf = y && y.record;
    const s = On(t, i), S = [E];
    if ("alias" in i) {
      const G = typeof i.alias == "string" ? [i.alias] : i.alias;
      for (const I of G) S.push(Mn(Q({}, E, {
        components: y ? y.record.components : E.components,
        path: I,
        aliasOf: y ? y.record : E
      })));
    }
    let b, R;
    for (const G of S) {
      const { path: I } = G;
      if (f && I[0] !== "/") {
        const B = f.record.path, T = B[B.length - 1] === "/" ? "" : "/";
        G.path = f.record.path + (I && T + I);
      }
      if (process.env.NODE_ENV !== "production" && G.path === "*") throw new Error(`Catch all routes ("*") must now be defined using a param with a custom regexp.
See more at https://router.vuejs.org/guide/migration/#Removed-star-or-catch-all-routes.`);
      if (b = Ni(G, f, s), process.env.NODE_ENV !== "production" && f && I[0] === "/" && Fi(b, f), y ? (y.alias.push(b), process.env.NODE_ENV !== "production" && Di(y, b)) : (R = R || b, R !== b && R.alias.push(b), l && i.name && !Fn(b) && (process.env.NODE_ENV !== "production" && Mi(i, f), v(i.name))), Po(b) && u(b), E.children) {
        const B = E.children;
        for (let T = 0; T < B.length; T++) c(B[T], b, y && y.children[T]);
      }
      y = y || b;
    }
    return R ? () => {
      v(R);
    } : Ue;
  }
  function v(i) {
    if (vo(i)) {
      const f = n.get(i);
      f && (n.delete(i), r.splice(r.indexOf(f), 1), f.children.forEach(v), f.alias.forEach(v));
    } else {
      const f = r.indexOf(i);
      f > -1 && (r.splice(f, 1), i.record.name && n.delete(i.record.name), i.children.forEach(v), i.alias.forEach(v));
    }
  }
  function d() {
    return r;
  }
  function u(i) {
    const f = qi(i, r);
    r.splice(f, 0, i), i.record.name && !Fn(i) && n.set(i.record.name, i);
  }
  function p(i, f) {
    let y, l = {}, E, s;
    if ("name" in i && i.name) {
      if (y = n.get(i.name), !y) throw ke(ae.MATCHER_NOT_FOUND, { location: i });
      if (process.env.NODE_ENV !== "production") {
        const R = Object.keys(i.params || {}).filter((G) => !y.keys.find((I) => I.name === G));
        R.length && V(`Discarded invalid param(s) "${R.join('", "')}" when navigating. See https://github.com/vuejs/router/blob/main/packages/router/CHANGELOG.md#414-2022-08-22 for more details.`);
      }
      s = y.record.name, l = Q(Tn(f.params, y.keys.filter((R) => !R.optional).concat(y.parent ? y.parent.keys.filter((R) => R.optional) : []).map((R) => R.name)), i.params && Tn(i.params, y.keys.map((R) => R.name))), E = y.stringify(l);
    } else if (i.path != null)
      E = i.path, process.env.NODE_ENV !== "production" && !E.startsWith("/") && V(`The Matcher cannot resolve relative paths but received "${E}". Unless you directly called \`matcher.resolve("${E}")\`, this is probably a bug in vue-router. Please open an issue at https://github.com/vuejs/router/issues/new/choose.`), y = r.find((R) => R.re.test(E)), y && (l = y.parse(E), s = y.record.name);
    else {
      if (y = f.name ? n.get(f.name) : r.find((R) => R.re.test(f.path)), !y) throw ke(ae.MATCHER_NOT_FOUND, {
        location: i,
        currentLocation: f
      });
      s = y.record.name, l = Q({}, f.params, i.params), E = y.stringify(l);
    }
    const S = [];
    let b = y;
    for (; b; )
      S.unshift(b.record), b = b.parent;
    return {
      name: s,
      path: E,
      params: l,
      matched: S,
      meta: xi(S)
    };
  }
  e.forEach((i) => c(i));
  function a() {
    r.length = 0, n.clear();
  }
  return {
    addRoute: c,
    resolve: p,
    removeRoute: v,
    clearRoutes: a,
    getRoutes: d,
    getRecordMatcher: o
  };
}
function Tn(e, t) {
  const r = {};
  for (const n of t) n in e && (r[n] = e[n]);
  return r;
}
function Mn(e) {
  const t = {
    path: e.path,
    redirect: e.redirect,
    name: e.name,
    meta: e.meta || {},
    aliasOf: e.aliasOf,
    beforeEnter: e.beforeEnter,
    props: Ci(e),
    children: e.children || [],
    instances: {},
    leaveGuards: /* @__PURE__ */ new Set(),
    updateGuards: /* @__PURE__ */ new Set(),
    enterCallbacks: {},
    components: "components" in e ? e.components || null : e.component && { default: e.component }
  };
  return Object.defineProperty(t, "mods", { value: {} }), t;
}
function Ci(e) {
  const t = {}, r = e.props || !1;
  if ("component" in e) t.default = r;
  else for (const n in e.components) t[n] = typeof r == "object" ? r[n] : r;
  return t;
}
function Fn(e) {
  for (; e; ) {
    if (e.record.aliasOf) return !0;
    e = e.parent;
  }
  return !1;
}
function xi(e) {
  return e.reduce((t, r) => Q(t, r.meta), {});
}
function dr(e, t) {
  return e.name === t.name && e.optional === t.optional && e.repeatable === t.repeatable;
}
function Di(e, t) {
  for (const r of e.keys) if (!r.optional && !t.keys.find(dr.bind(null, r))) return V(`Alias "${t.record.path}" and the original record: "${e.record.path}" must have the exact same param named "${r.name}"`);
  for (const r of t.keys) if (!r.optional && !e.keys.find(dr.bind(null, r))) return V(`Alias "${t.record.path}" and the original record: "${e.record.path}" must have the exact same param named "${r.name}"`);
}
function Ti(e, t) {
  t && t.record.name && !e.name && !e.path && V(`The route named "${String(t.record.name)}" has a child without a name and an empty path. Using that name won't render the empty path child so you probably want to move the name to the child instead. If this is intentional, add a name to the child route to remove the warning.`);
}
function Mi(e, t) {
  for (let r = t; r; r = r.parent) if (r.record.name === e.name) throw new Error(`A route named "${String(e.name)}" has been added as a ${t === r ? "child" : "descendant"} of a route with the same name. Route names must be unique and a nested route cannot use the same name as an ancestor.`);
}
function Fi(e, t) {
  for (const r of t.keys) if (!e.keys.find(dr.bind(null, r))) return V(`Absolute path "${e.record.path}" must have the exact same param named "${r.name}" as its parent "${t.record.path}".`);
}
function qi(e, t) {
  let r = 0, n = t.length;
  for (; r !== n; ) {
    const c = r + n >> 1;
    Ro(e, t[c]) < 0 ? n = c : r = c + 1;
  }
  const o = ki(e);
  return o && (n = t.lastIndexOf(o, n - 1), process.env.NODE_ENV !== "production" && n < 0 && V(`Finding ancestor route "${o.record.path}" failed for "${e.record.path}"`)), n;
}
function ki(e) {
  let t = e;
  for (; t = t.parent; ) if (Po(t) && Ro(e, t) === 0) return t;
}
function Po({ record: e }) {
  return !!(e.name || e.components && Object.keys(e.components).length || e.redirect);
}
function qn(e) {
  const t = je(gr), r = je(mo);
  let n = !1, o = null;
  const c = me(() => {
    const a = Fe(e.to);
    return process.env.NODE_ENV !== "production" && (!n || a !== o) && (Je(a) || (n ? V(`Invalid value for prop "to" in useLink()
- to:`, a, `
- previous to:`, o, `
- props:`, e) : V(`Invalid value for prop "to" in useLink()
- to:`, a, `
- props:`, e)), o = a, n = !0), t.resolve(a);
  }), v = me(() => {
    const { matched: a } = c.value, { length: i } = a, f = a[i - 1], y = r.matched;
    if (!f || !y.length) return -1;
    const l = y.findIndex(Re.bind(null, f));
    if (l > -1) return l;
    const E = kn(a[i - 2]);
    return i > 1 && kn(f) === E && y[y.length - 1].path !== E ? y.findIndex(Re.bind(null, a[i - 2])) : l;
  }), d = me(() => v.value > -1 && Vi(r.params, c.value.params)), u = me(() => v.value > -1 && v.value === r.matched.length - 1 && ho(r.params, c.value.params));
  function p(a = {}) {
    if (Gi(a)) {
      const i = t[Fe(e.replace) ? "replace" : "push"](Fe(e.to)).catch(Ue);
      return e.viewTransition && typeof document < "u" && "startViewTransition" in document && document.startViewTransition(() => i), i;
    }
    return Promise.resolve();
  }
  if (process.env.NODE_ENV !== "production" && Ee) {
    const a = Un();
    if (a) {
      const i = {
        route: c.value,
        isActive: d.value,
        isExactActive: u.value,
        error: null
      };
      a.__vrl_devtools = a.__vrl_devtools || [], a.__vrl_devtools.push(i), Go(() => {
        i.route = c.value, i.isActive = d.value, i.isExactActive = u.value, i.error = Je(Fe(e.to)) ? null : 'Invalid "to" value';
      }, { flush: "post" });
    }
  }
  return {
    route: c,
    href: me(() => c.value.href),
    isActive: d,
    isExactActive: u,
    navigate: p
  };
}
function Li(e) {
  return e.length === 1 ? e[0] : e;
}
const $i = /* @__PURE__ */ Gn({
  name: "RouterLink",
  compatConfig: { MODE: 3 },
  props: {
    to: {
      type: [String, Object],
      required: !0
    },
    replace: Boolean,
    activeClass: String,
    exactActiveClass: String,
    custom: Boolean,
    ariaCurrentValue: {
      type: String,
      default: "page"
    },
    viewTransition: Boolean
  },
  useLink: qn,
  setup(e, { slots: t }) {
    const r = $o(qn(e)), { options: n } = je(gr), o = me(() => ({
      [Ln(e.activeClass, n.linkActiveClass, "router-link-active")]: r.isActive,
      [Ln(e.exactActiveClass, n.linkExactActiveClass, "router-link-exact-active")]: r.isExactActive
    }));
    return () => {
      const c = t.default && Li(t.default(r));
      return e.custom ? c : Vn("a", {
        "aria-current": r.isExactActive ? e.ariaCurrentValue : null,
        href: r.href,
        onClick: r.navigate,
        class: o.value
      }, c);
    };
  }
}), Bi = $i;
function Gi(e) {
  if (!(e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) && !e.defaultPrevented && !(e.button !== void 0 && e.button !== 0)) {
    if (e.currentTarget && e.currentTarget.getAttribute) {
      const t = e.currentTarget.getAttribute("target");
      if (/\b_blank\b/i.test(t)) return;
    }
    return e.preventDefault && e.preventDefault(), !0;
  }
}
function Vi(e, t) {
  for (const r in t) {
    const n = t[r], o = e[r];
    if (typeof n == "string") {
      if (n !== o) return !1;
    } else if (!fe(o) || o.length !== n.length || n.some((c, v) => c.valueOf() !== o[v].valueOf())) return !1;
  }
  return !0;
}
function kn(e) {
  return e ? e.aliasOf ? e.aliasOf.path : e.path : "";
}
const Ln = (e, t, r) => e ?? t ?? r, Ui = /* @__PURE__ */ Gn({
  name: "RouterView",
  inheritAttrs: !1,
  props: {
    name: {
      type: String,
      default: "default"
    },
    route: Object
  },
  compatConfig: { MODE: 3 },
  setup(e, { attrs: t, slots: r }) {
    process.env.NODE_ENV !== "production" && Wi();
    const n = je(fr), o = me(() => e.route || n.value), c = je(In, 0), v = me(() => {
      let p = Fe(c);
      const { matched: a } = o.value;
      let i;
      for (; (i = a[p]) && !i.components; ) p++;
      return p;
    }), d = me(() => o.value.matched[v.value]);
    ct(In, me(() => v.value + 1)), ct(ni, d), ct(fr, o);
    const u = Bo();
    return Bn(() => [
      u.value,
      d.value,
      e.name
    ], ([p, a, i], [f, y, l]) => {
      a && (a.instances[i] = p, y && y !== a && p && p === f && (a.leaveGuards.size || (a.leaveGuards = y.leaveGuards), a.updateGuards.size || (a.updateGuards = y.updateGuards))), p && a && (!y || !Re(a, y) || !f) && (a.enterCallbacks[i] || []).forEach((E) => E(p));
    }, { flush: "post" }), () => {
      const p = o.value, a = e.name, i = d.value, f = i && i.components[a];
      if (!f) return $n(r.default, {
        Component: f,
        route: p
      });
      const y = i.props[a], l = y ? y === !0 ? p.params : typeof y == "function" ? y(p) : y : null, s = Vn(f, Q({}, l, t, {
        onVnodeUnmounted: (S) => {
          S.component.isUnmounted && (i.instances[a] = null);
        },
        ref: u
      }));
      if (process.env.NODE_ENV !== "production" && Ee && s.ref) {
        const S = {
          depth: v.value,
          name: i.name,
          path: i.path,
          meta: i.meta
        };
        (fe(s.ref) ? s.ref.map((b) => b.i) : [s.ref.i]).forEach((b) => {
          b.__vrv_devtools = S;
        });
      }
      return $n(r.default, {
        Component: s,
        route: p
      }) || s;
    };
  }
});
function $n(e, t) {
  if (!e) return null;
  const r = e(t);
  return r.length === 1 ? r[0] : r;
}
const ji = Ui;
function Wi() {
  const e = Un(), t = e.parent && e.parent.type.name, r = e.parent && e.parent.subTree && e.parent.subTree.type;
  if (t && (t === "KeepAlive" || t.includes("Transition")) && typeof r == "object" && r.name === "RouterView") {
    const n = t === "KeepAlive" ? "keep-alive" : "transition";
    V(`<router-view> can no longer be used directly inside <transition> or <keep-alive>.
Use slot props instead:

<router-view v-slot="{ Component }">
  <${n}>
    <component :is="Component" />
  </${n}>
</router-view>`);
  }
}
function Yi(e) {
  const t = Ii(e.routes, e), r = e.parseQuery || ti, n = e.stringifyQuery || Nn, o = e.history;
  if (process.env.NODE_ENV !== "production" && !o) throw new Error('Provide the "history" option when calling "createRouter()": https://router.vuejs.org/api/interfaces/RouterOptions.html#history');
  const c = Ge(), v = Ge(), d = Ge(), u = ko(Se);
  let p = Se;
  Ee && e.scrollBehavior && "scrollRestoration" in history && (history.scrollRestoration = "manual");
  const a = tr.bind(null, (g) => "" + g), i = tr.bind(null, $a), f = tr.bind(null, qe);
  function y(g, N) {
    let _, P;
    return vo(g) ? (_ = t.getRecordMatcher(g), process.env.NODE_ENV !== "production" && !_ && V(`Parent route "${String(g)}" not found when adding child route`, N), P = N) : P = g, t.addRoute(P, _);
  }
  function l(g) {
    const N = t.getRecordMatcher(g);
    N ? t.removeRoute(N) : process.env.NODE_ENV !== "production" && V(`Cannot remove non-existent route "${String(g)}"`);
  }
  function E() {
    return t.getRoutes().map((g) => g.record);
  }
  function s(g) {
    return !!t.getRecordMatcher(g);
  }
  function S(g, N) {
    if (N = Q({}, N || u.value), typeof g == "string") {
      const F = rr(r, g, N.path), K = t.resolve({ path: F.path }, N), ee = o.createHref(F.fullPath);
      return process.env.NODE_ENV !== "production" && (ee.startsWith("//") ? V(`Location "${g}" resolved to "${ee}". A resolved location cannot start with multiple slashes.`) : K.matched.length || V(`No match found for location with path "${g}"`)), Q(F, K, {
        params: f(K.params),
        hash: qe(F.hash),
        redirectedFrom: void 0,
        href: ee
      });
    }
    if (process.env.NODE_ENV !== "production" && !Je(g))
      return V(`router.resolve() was passed an invalid location. This will fail in production.
- Location:`, g), S({});
    let _;
    if (g.path != null)
      process.env.NODE_ENV !== "production" && "params" in g && !("name" in g) && Object.keys(g.params).length && V(`Path "${g.path}" was passed with params but they will be ignored. Use a named route alongside params instead.`), _ = Q({}, g, { path: rr(r, g.path, N.path).path });
    else {
      const F = Q({}, g.params);
      for (const K in F) F[K] == null && delete F[K];
      _ = Q({}, g, { params: i(F) }), N.params = i(N.params);
    }
    const P = t.resolve(_, N), D = g.hash || "";
    process.env.NODE_ENV !== "production" && D && !D.startsWith("#") && V(`A \`hash\` should always start with the character "#". Replace "${D}" with "#${D}".`), P.params = a(f(P.params));
    const L = Va(n, Q({}, g, {
      hash: qa(D),
      path: P.path
    })), M = o.createHref(L);
    return process.env.NODE_ENV !== "production" && (M.startsWith("//") ? V(`Location "${g}" resolved to "${M}". A resolved location cannot start with multiple slashes.`) : P.matched.length || V(`No match found for location with path "${g.path != null ? g.path : g}"`)), Q({
      fullPath: L,
      hash: D,
      query: n === Nn ? ri(g.query) : g.query || {}
    }, P, {
      redirectedFrom: void 0,
      href: M
    });
  }
  function b(g) {
    return typeof g == "string" ? rr(r, g, u.value.path) : Q({}, g);
  }
  function R(g, N) {
    if (p !== g) return ke(ae.NAVIGATION_CANCELLED, {
      from: N,
      to: g
    });
  }
  function G(g) {
    return T(g);
  }
  function I(g) {
    return G(Q(b(g), { replace: !0 }));
  }
  function B(g, N) {
    const _ = g.matched[g.matched.length - 1];
    if (_ && _.redirect) {
      const { redirect: P } = _;
      let D = typeof P == "function" ? P(g, N) : P;
      if (typeof D == "string" && (D = D.includes("?") || D.includes("#") ? D = b(D) : { path: D }, D.params = {}), process.env.NODE_ENV !== "production" && D.path == null && !("name" in D))
        throw V(`Invalid redirect found:
${JSON.stringify(D, null, 2)}
 when navigating to "${g.fullPath}". A redirect must contain a name or path. This will break in production.`), new Error("Invalid redirect");
      return Q({
        query: g.query,
        hash: g.hash,
        params: D.path != null ? {} : g.params
      }, D);
    }
  }
  function T(g, N) {
    const _ = p = S(g), P = u.value, D = g.state, L = g.force, M = g.replace === !0, F = B(_, P);
    if (F) return T(Q(b(F), {
      state: typeof F == "object" ? Q({}, D, F.state) : D,
      force: L,
      replace: M
    }), N || _);
    const K = _;
    K.redirectedFrom = N;
    let ee;
    return !L && _n(n, P, _) && (ee = ke(ae.NAVIGATION_DUPLICATED, {
      to: K,
      from: P
    }), q(P, P, !0, !1)), (ee ? Promise.resolve(ee) : O(K, P)).catch((j) => ge(j) ? ge(j, ae.NAVIGATION_GUARD_REDIRECT) ? j : x(j) : X(j, K, P)).then((j) => {
      if (j) {
        if (ge(j, ae.NAVIGATION_GUARD_REDIRECT))
          return process.env.NODE_ENV !== "production" && _n(n, S(j.to), K) && N && (N._count = N._count ? N._count + 1 : 1) > 30 ? (V(`Detected a possibly infinite redirection in a navigation guard when going from "${P.fullPath}" to "${K.fullPath}". Aborting to avoid a Stack Overflow.
 Are you always returning a new location within a navigation guard? That would lead to this error. Only return when redirecting or aborting, that should fix this. This might break in production if not fixed.`), Promise.reject(/* @__PURE__ */ new Error("Infinite redirect in navigation guard"))) : T(Q({ replace: M }, b(j.to), {
            state: typeof j.to == "object" ? Q({}, D, j.to.state) : D,
            force: L
          }), N || K);
      } else j = k(K, P, !0, M, D);
      return A(K, P, j), j;
    });
  }
  function C(g, N) {
    const _ = R(g, N);
    return _ ? Promise.reject(_) : Promise.resolve();
  }
  function w(g) {
    const N = pe.values().next().value;
    return N && typeof N.runWithContext == "function" ? N.runWithContext(g) : g();
  }
  function O(g, N) {
    let _;
    const [P, D, L] = ai(g, N);
    _ = or(P.reverse(), "beforeRouteLeave", g, N);
    for (const F of P) F.leaveGuards.forEach((K) => {
      _.push(_e(K, g, N));
    });
    const M = C.bind(null, g, N);
    return _.push(M), ie(_).then(() => {
      _ = [];
      for (const F of c.list()) _.push(_e(F, g, N));
      return _.push(M), ie(_);
    }).then(() => {
      _ = or(D, "beforeRouteUpdate", g, N);
      for (const F of D) F.updateGuards.forEach((K) => {
        _.push(_e(K, g, N));
      });
      return _.push(M), ie(_);
    }).then(() => {
      _ = [];
      for (const F of L) if (F.beforeEnter) if (fe(F.beforeEnter)) for (const K of F.beforeEnter) _.push(_e(K, g, N));
      else _.push(_e(F.beforeEnter, g, N));
      return _.push(M), ie(_);
    }).then(() => (g.matched.forEach((F) => F.enterCallbacks = {}), _ = or(L, "beforeRouteEnter", g, N, w), _.push(M), ie(_))).then(() => {
      _ = [];
      for (const F of v.list()) _.push(_e(F, g, N));
      return _.push(M), ie(_);
    }).catch((F) => ge(F, ae.NAVIGATION_CANCELLED) ? F : Promise.reject(F));
  }
  function A(g, N, _) {
    d.list().forEach((P) => w(() => P(g, N, _)));
  }
  function k(g, N, _, P, D) {
    const L = R(g, N);
    if (L) return L;
    const M = N === Se, F = Ee ? history.state : {};
    _ && (P || M ? o.replace(g.fullPath, Q({ scroll: M && F && F.scroll }, D)) : o.push(g.fullPath, D)), u.value = g, q(g, N, _, M), x();
  }
  let W;
  function $() {
    W || (W = o.listen((g, N, _) => {
      if (!de.listening) return;
      const P = S(g), D = B(P, de.currentRoute.value);
      if (D) {
        T(Q(D, {
          replace: !0,
          force: !0
        }), P).catch(Ue);
        return;
      }
      p = P;
      const L = u.value;
      Ee && Ja(Pn(L.fullPath, _.delta), Ze()), O(P, L).catch((M) => ge(M, ae.NAVIGATION_ABORTED | ae.NAVIGATION_CANCELLED) ? M : ge(M, ae.NAVIGATION_GUARD_REDIRECT) ? (T(Q(b(M.to), { force: !0 }), P).then((F) => {
        ge(F, ae.NAVIGATION_ABORTED | ae.NAVIGATION_DUPLICATED) && !_.delta && _.type === ur.pop && o.go(-1, !1);
      }).catch(Ue), Promise.reject()) : (_.delta && o.go(-_.delta, !1), X(M, P, L))).then((M) => {
        M = M || k(P, L, !1), M && (_.delta && !ge(M, ae.NAVIGATION_CANCELLED) ? o.go(-_.delta, !1) : _.type === ur.pop && ge(M, ae.NAVIGATION_ABORTED | ae.NAVIGATION_DUPLICATED) && o.go(-1, !1)), A(P, L, M);
      }).catch(Ue);
    }));
  }
  let Y = Ge(), z = Ge(), H;
  function X(g, N, _) {
    x(g);
    const P = z.list();
    return P.length ? P.forEach((D) => D(g, N, _)) : (process.env.NODE_ENV !== "production" && V("uncaught error during route navigation:"), console.error(g)), Promise.reject(g);
  }
  function Z() {
    return H && u.value !== Se ? Promise.resolve() : new Promise((g, N) => {
      Y.add([g, N]);
    });
  }
  function x(g) {
    return H || (H = !g, $(), Y.list().forEach(([N, _]) => g ? _(g) : N()), Y.reset()), g;
  }
  function q(g, N, _, P) {
    const { scrollBehavior: D } = e;
    if (!Ee || !D) return Promise.resolve();
    const L = !_ && Ya(Pn(g.fullPath, 0)) || (P || !_) && history.state && history.state.scroll || null;
    return Lo().then(() => D(g, N, L)).then((M) => M && Qa(M)).catch((M) => X(M, g, N));
  }
  const ne = (g) => o.go(g);
  let ue;
  const pe = /* @__PURE__ */ new Set(), de = {
    currentRoute: u,
    listening: !0,
    addRoute: y,
    removeRoute: l,
    clearRoutes: t.clearRoutes,
    hasRoute: s,
    getRoutes: E,
    resolve: S,
    options: e,
    push: G,
    replace: I,
    go: ne,
    back: () => ne(-1),
    forward: () => ne(1),
    beforeEach: c.add,
    beforeResolve: v.add,
    afterEach: d.add,
    onError: z.add,
    isReady: Z,
    install(g) {
      g.component("RouterLink", Bi), g.component("RouterView", ji), g.config.globalProperties.$router = de, Object.defineProperty(g.config.globalProperties, "$route", {
        enumerable: !0,
        get: () => Fe(u)
      }), Ee && !ue && u.value === Se && (ue = !0, G(o.location).catch((P) => {
        process.env.NODE_ENV !== "production" && V("Unexpected error when starting the router:", P);
      }));
      const N = {};
      for (const P in Se) Object.defineProperty(N, P, {
        get: () => u.value[P],
        enumerable: !0
      });
      g.provide(gr, de), g.provide(mo, qo(N)), g.provide(fr, u);
      const _ = g.unmount;
      pe.add(g), g.unmount = function() {
        pe.delete(g), pe.size < 1 && (p = Se, W && W(), W = null, u.value = Se, ue = !1, H = !1), _();
      }, process.env.NODE_ENV !== "production" && Ee && li(g, de, t);
    }
  };
  function ie(g) {
    return g.reduce((N, _) => N.then(() => w(_)), Promise.resolve());
  }
  return de;
}
export {
  Yi as a,
  Ji as b,
  zi as c,
  Ki as f,
  Qi as q
};
